<template>
  <div class="pro_xq_d">
    <el-dialog class="main_dialog" :title="projectName" width="900px" :visible.sync="dialogFormVisible" :before-close="refreshUp">
      <div class="pro_type"><img src="../developed/icon_anzhuang.png"></div>
      <p class="project-num">项目单号：{{projectId}}</p>
      <div class="top-price">
        <div class="p-price">
          <div class="p-yuan">¥</div>
          <div class="fz-28">{{projectInfo.priceSum?projectInfo.priceSum:projectInfo.price}}</div>
        </div>
      </div>
      <!-- 项目状态图标 -->
      <div class="pro_state">
        <img v-if="state == -2" src="../developed/xmqx.png">
        <img v-else-if="state == -1" src="../developed/wfb.png">
        <img v-else-if="state == 0" src="../developed/zzzm.png">
        <img v-else-if="state == 1" src="../developed/ddzx.png">
        <img v-else-if="state == 2" src="../developed/xmqx.png">
        <img v-else-if="state == 3" src="../developed/xmcs.png">
        <img v-else-if="state == 4" src="../developed/zzzx.png">
        <img v-else-if="state == 5" src="../developed/ddjx.png">
        <img v-else-if="state == 6" src="../developed/jjjx.png">
        <img v-else-if="state == 7" src="../developed/xmwj.png">
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- tabs切换栏 -->
        <!-- 1.项目详情 -->
        <el-tab-pane label="项目详情" name="first">
          <!-- 头像 -->
          <div class="avatar_list">
            <div class="left_img">
              <!-- <a><img src="../../../public/img/default-avatar.png"></a> -->
              <a>
                <img :src='creatUserInfo.avatar?creatUserInfo.avatar:(creatUserInfo.headimgurl?creatUserInfo.headimgurl:"img/default-avatar.png")'>
              </a>
              <a class="c_gray fz_12">{{userName}} 于 {{createTime}} 发布项目</a>
              <a v-if="state==0&&isEditAuth" @click="isShowFbDlg"><img class="sendWays_rewrite" src="../../../public/img/orderInfo2/rewrite.png"></a>
            </div>
            <div class="left_img" v-if="foremanInfo.length>0">
              <a><img :src='foremanInfo[0].headimgurl?foremanInfo[0].headimgurl:"img/default-avatar.png"'></a>
              <a class="c_gray fz_12">{{foremanInfo[0].name}} 于 {{ foremanInfo[0].createTime }} 承接项目</a>
            </div>
          </div>
          <!-- 项目相关人 -->
          <el-container class="pro_xq_container" style="padding-top: 10px;padding-bottom: 10px;">
            <el-aside class="pro_aside">
              <div>项目相关人</div>
            </el-aside>
            <el-main class="pro_main">
              <div :class='stakeholders.length>0?"pb_15":""' style="position: relative;">
                <a class="main_tips pl_10">{{stakeholders.length}}人</a>
                <a v-if="(state==0||state==1||state==4||state==5||state==6)&&isEditAuth" @click="stakeholdersDlgShow" class="rewrite">
                  <img src="../../../public/img/orderInfo2/rewrite.png">
                 </a>
              </div>
              <div class="man_list stakeholdersList">
                <div class="ava_img" style="min-width: 70px;" v-for="(item,index) in stakeholders" :key="index">
                  <div class="stakeholdersImg">
                    <img :src='item.avatar?item.avatar:(item.headimgurl&&item.headimgurl!=""?item.headimgurl:"img/default-avatar.png")' />
                  </div>
                  <div class="ava_name">{{item.userName}}</div>
                </div>
              </div>
            </el-main>
          </el-container>
          <!-- 项目地址及相关联系人 -->
          <div class="por_ads_altCon">

            <div class="pro_address">
              <el-container v-for="(item,index) in relevantContacts" :key="index" class="pb_24">
                <el-aside class="pro_aside">
                  <div>协作联系人{{index+1}}</div>
                </el-aside>
                <el-main class="pro_main pb_0">
                  <div style="line-height: 40px;position: relative;">
                    <a>{{item.type}}</a>
                    <a>{{item.name}}</a>
                    <a class="ml_15">{{item.phone}}</a>
                    <a v-if="(state==0||state==1)&&isEditAuth" @click="isShowXzDlg(item,index)" class="rewrite" style="position: absolute;right: 65px;">
                      <img src="../../../public/img/orderInfo2/rewrite.png">
                    </a>
                  </div>
                </el-main>
              </el-container>
            </div>


            <div class="clearfix"></div>
            <!-- 项目地址 -->
            <div class="pro_address">
              <el-container v-for="(item,index) in address" :key="index" class="pb_24">
                <el-aside class="pro_aside">
                  <div>项目地址{{address.length>1?index+1:''}}</div>
                </el-aside>
                <el-main class="pro_main pb_0">
                  <div style="line-height: 40px;position: relative;">
                    <a class="main_address" style="max-width: 430px;word-break: break-all;">
                      {{item.address}}
                      <a class="mark" style="height: 25px;">
                      <img src="../../../public/img/orderInfo2/mark.png">
                    </a>
                    </a>
                    <a class="main_tips ml_40">{{item.contacts}}</a>
                    <a class="main_tips ml_10">{{item.contactPhone}}</a>
                    <a v-if="(state==0||state==1)&&isEditAuth" class="rewrite" @click="showContactsDlg(item,index)" style="position: absolute;right: 65px;">
                      <img src="../../../public/img/orderInfo2/rewrite.png" style="vertical-align: text-bottom;">
                    </a>
                  </div>
                </el-main>
              </el-container>
            </div>
          </div>
          <!-- 验收报告 -->
          <el-container class="pro_xq_container bd_t_b_none" v-if="getReports.length>0">
            <el-aside class="pro_aside">
              <div>验收报告</div>
            </el-aside>
            <el-main class="pro_main">
              <myPicList ref="mypicList" :list='getReports' @refresh="refresh"></myPicList>
            </el-main>
          </el-container>
          <!-- 拒绝结项原因展示 -->
          <el-container class="pro_xq_container bd_t_b_none" v-if="state == 6">
            <el-aside class="pro_aside">
              <div>拒绝结项</div>
            </el-aside>
            <el-main class="pro_main">
              <div v-for='(item,index) in refuseLog' :key="index" class="refuseRes">
                <div>{{item.contentData}}</div>
                <div style="text-align: right; color: #BFC2CC;">
                 <span style="padding-right: 20px;">{{item.userName}}</span>
                 <span>{{item.createTime}}</span>
                </div>
              </div>
            </el-main>
          </el-container>
          <!-- 工作内容 -->
          <el-container class="pro_xq_container bd_t_b_none">
            <el-aside class="pro_aside">
              <div>工作内容</div>
              <a class="aside_tips">共{{domains.length}}条</a>
            </el-aside>
            <el-main class="pro_main">
              <div class="keysearch" v-if="contentShowNum.isMore">
                <el-input placeholder="搜索关键字" prefix-icon="el-icon-search" @input="searchWorkContent" v-model="keyword">
                </el-input>
                <el-button @click="searchWorkContent" type="primary" style="font-size: 12px;font-weight: 400;">搜索</el-button>
              </div>
              <div class="man_list">
                <div class="info_text" style="width: 100%;" v-for="(item,index) in domains" v-if='index<=contentShowNum.data-1'
                  :key="index" @click="openContentInfo(item)">
                  <div>{{index+1+'.'}}{{item.tips}}</div>
                  <a class="pic"><img style="width: 17px;height: 15px;" src="../../../public/img/addProject/pic.png">{{item.imgNum?item.imgNum:0}}(张)</a>
                  <a class="vid"><img style="width: 17px;height: 15px;" src="../../../public/img/addProject/video.png">{{item.videoNum?item.videoNum:0}}(个)</a>
                </div>
              </div>
              <p class="fz_12 c_blue text_r" @click="showMore" v-if="domains.length>=10"><a class="hover">{{contentShowNum.isMore?'收起':'查看更多'}}</a></p>
            </el-main>
          </el-container>
          <!-- 备注 -->
          <el-container class="pro_xq_container bd_t_b_none" style="padding-top: 10px;padding-bottom: 10px;">
            <el-aside class="pro_aside">
              <div>备注</div>
            </el-aside>
            <el-main class="pro_main">
              <div style="position: relative;">
                <a class="main_tips" style="margin-right: 25px;">{{describe}}</a>
                <a v-if="(state==0||state==1)&&isEditAuth" @click="isShowBzDlg" class="rewrite"><img src="../../../public/img/orderInfo2/rewrite.png"></a>
              </div>
            </el-main>
          </el-container>
          <!-- 附件 -->
          <el-container class="pro_xq_container bd_t_b_none">
            <el-aside class="pro_aside">
              <div>附件</div>
              <a class="aside_tips">共{{filePathsEl.length}}个</a>
            </el-aside>
            <el-main class="pro_main" style="position: relative;">
              <a v-if="(state==0||state==1)&&isEditAuth" class="rewrite mt_9" @click="isShowFjDlg"><img src="../../../public/img/orderInfo2/rewrite.png"></a>
              <div class="width_95">
                <div v-for="(item,index) in filePathsEl" :key="index" class="fj_type">
                  <img src="../../../public/img/addProject/png.png" v-if="item.type=='png'">
                  <img src="../../../public/img/addProject/PDF.png" v-if="item.type=='pdf'">
                  <img src="../../../public/img/addProject/jpg.png" v-if="item.type=='jpg'">
                  <img src="../../../public/img/addProject/excel.png" v-if="item.type=='excel'">
                  <img src="../../../public/img/addProject/doc.png" v-if="item.type=='word'">
                  <a class="fjName" :href="item.url|getBaseImgUrl" target="view_window" :download="item.name">{{item.name}}</a>
                </div>
              </div>
            </el-main>
          </el-container>
          <!-- 排班计划 -->
          <div>

            <el-container class="pro_xq_container bd_t_b_none" style="padding-top: 10px;padding-bottom: 10px;">
              <el-aside class="pro_aside">
                <div>项目计划</div>
              </el-aside>
              <el-main class="pro_main">
                <div style="position: relative;">
                  <a class="main_tips" style="margin-right: 25px;"></a>

                </div>
              </el-main>
            </el-container>
            <div  :class="(state==0||state==1||state==2||state==3||state==5)&&isEditAuth?'pb_table':'pb_table mb_20 border_bottom'" >

              <div class="qr_main_1 table_margin" style="padding-top:0px;">
                <el-row class="pro_container" :gutter="20"  style="border-bottom:1px solid #edeff2;">
                  <el-col :span="10">
                    <span class="pro_jh_title" style="margin-right: 15px;font-size:14px;color:#303133;font-weight:500;">预计工期：{{duration}}天</span>
                  </el-col>
                  <el-col :span="9">
                    <span class="pro_jh_title" style="margin-right: 28px;font-size:14px;color:#303133;font-weight:500;">开始时间：{{startTime}}</span>
                  </el-col>
                  <el-col :span="5" style="position:relative;">
                    <a v-if="(state==0||state==1||state==4||state==5||state==6)&&isEditAuth" class="rewrite" style="right:10px;" @click="isShowPlanDateDlg"><img src="../../../public/img/orderInfo2/rewrite.png"></a>
                  </el-col>
                </el-row>
                <el-container class="pro_container" style="border-bottom:1px solid #edeff2">
                  <el-aside class="pro_title" style="width:100px;">
                    <div style="font-size:14px;color:#303133;font-weight:500;">现场勘查计划</div>
                  </el-aside>
                  <el-main class="pro_main" style="padding-right: 0px;overflow:visible;">
                    <el-row>
                      <div class="pro_content_li text_start"  v-for="(item,index) in prospecting" :key="index"  style="border-bottom:1px solid #edeff2">
                        <div class="li_index" @click="planDataInfo(1,item)">{{index+1}}</div>
                        <div class="li_info" style="cursor: pointer;" @click="planDataInfo(1,item)">
                          <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                          <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                        </div>
                        <div style="width:20px;position:relative;">
                          <a v-if="(state==0||state==1||state==4||state==5||state==6)&&isEditAuth&&item.status==0"  @click="editPlanData(1,item)"  style="width: 16px;min-height: 20px;position:absolute;right: 0px;cursor: pointer"><img src="../../../public/img/orderInfo2/rewrite.png" style="width: 16px;height: 16px;"></a>
                        </div>
                      </div>
                    </el-row>
                    <div class="pro_content_li text_start"  v-if="prospecting.length==0">
                      无
                    </div>
                  </el-main>
                </el-container>
                <el-container class="pro_container"  style="border-bottom:1px solid #edeff2">
                  <el-aside class="pro_title" style="width:100px;">
                    <div style="font-size:14px;color:#303133;font-weight:500;">到货计划</div>
                  </el-aside>
                  <el-main class="pro_main"  style="padding-right: 0px;overflow:visible;">

                    <el-row>
                      <div class="pro_content_li text_start"  v-for="(item,index) in daohuoPlanList" :key="index">
                        <div class="li_index" @click="planDataInfo(2,item)">{{index+1}}</div>
                        <div class="li_info" style="cursor: pointer;" @click="planDataInfo(2,item)">
                          <el-col :span="24" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.logisticsCompany}}({{item.logisticsNo}})</el-col>
                          <el-col :span="24" v-if="item.arrivalMode=='自提'"  class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">
                            {{item.arrivalDataInfo.addr}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.arrivalDataInfo.jianshu}}件&nbsp;&nbsp;&nbsp;&nbsp;{{item.arrivalDataInfo.fangshu}}方
                          </el-col>

                          <el-col :span="24" v-if="item.arrivalMode=='货到现场'" v-for="(carIformation,index) in item.carIformationList" :key="index" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">
                            {{carIformation.carModel}}&nbsp;&nbsp;{{carIformation.number}}件&nbsp;&nbsp;{{carIformation.SquareNumber}}方
                          </el-col>

                          <el-col :span="12" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">联系人：{{item.logisticsUser}}&nbsp;&nbsp;联系电话：{{item.phone}}</el-col>
                          <el-col :span="12" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all; text-align: right;">是否需要转运：{{item.isTransport}}&nbsp;到货方式：{{item.arrivalMode}}</el-col>
                        </div>
                        <div style="width:20px;position:relative;">
                          <a v-if="(state==0||state==1||state==4||state==5||state==6)&&isEditAuth&&item.status==0"  @click="editPlanData(2,item)"  style="width: 16px;min-height: 20px;position:absolute;right: 0px;cursor: pointer"><img src="../../../public/img/orderInfo2/rewrite.png" style="width: 16px;height: 16px;"></a>
                        </div>

                      </div>
                      <div class="pro_content_li text_start" v-if="daohuoPlanList.length==0">
                        无
                      </div>
                    </el-row>
                  </el-main>
                </el-container>
                <el-container class="pro_container"  style="border-bottom:1px solid #edeff2">
                  <el-aside class="pro_title" style="width:100px;">
                    <div style="font-size:14px;color:#303133;font-weight:500;">安装计划</div>
                  </el-aside>
                  <el-main class="pro_main"  style="padding-right: 0px;overflow:visible;">

                    <el-row>
                      <div class="pro_content_li text_start"  v-for="(item,index) in installationPlanList" :key="index">
                        <div class="li_index" @click="planDataInfo(3,item)">{{index+1}}</div>
                        <div class="li_info" style="cursor: pointer;" @click="planDataInfo(3,item)">
                          <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                          <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">安装工：{{item.anzhuangNum}}人 搬运工：{{item.banyunNum}}人 &nbsp;&nbsp;{{item.workOvertime==0?'无需加班':'需要加班'}}</p>
                          <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                        </div>
                        <div style="width:20px;position:relative;">
                          <a v-if="(state==0||state==1||state==4||state==5||state==6)&&isEditAuth&&item.status==0"  @click="editPlanData(3,item)"  style="width: 16px;min-height: 20px;position:absolute;right: 0px;cursor: pointer"><img src="../../../public/img/orderInfo2/rewrite.png" style="width: 16px;height: 16px;"></a>
                        </div>
                      </div>
                      <div class="pro_content_li text_start" v-if="installationPlanList.length==0">
                        无
                      </div>
                    </el-row>
                  </el-main>
                </el-container>
                <el-container class="pro_container"  style="border-bottom:1px solid #edeff2">
                  <el-aside class="pro_title" style="width:100px;">
                    <div style="font-size:14px;color:#303133;font-weight:500;">验收计划</div>
                  </el-aside>
                  <el-main class="pro_main"  style="padding-right: 0px;overflow:visible;">
                    <el-row>
                      <div class="pro_content_li text_start"  v-for="(item,index) in arrivalPlanList" :key="index">
                        <div class="li_index" @click="planDataInfo(4,item)">{{index+1}}</div>
                        <div class="li_info" style="cursor: pointer;" @click="planDataInfo(4,item)">
                          <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                          <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                        </div>
                        <div style="width:20px;position:relative;">
                          <a v-if="(state==0||state==1||state==4||state==5||state==6)&&isEditAuth&&item.status==0"  @click="editPlanData(4,item)"  style="width: 16px;min-height: 20px;position:absolute;right: 0px;cursor: pointer"><img src="../../../public/img/orderInfo2/rewrite.png" style="width: 16px;height: 16px;"></a>
                        </div>
                      </div>
                      <div class="pro_content_li text_start"  v-if="arrivalPlanList.length==0">
                        无
                      </div>
                    </el-row>
                  </el-main>
                </el-container>
                <el-container class="pro_container" >
                  <el-aside class="pro_title" style="width:100px;">
                    <div style="font-size:14px;color:#303133;font-weight:500;">回访计划</div>
                  </el-aside>
                  <el-main class="pro_main"  style="padding-right: 0px;overflow:visible;">
                    <el-row>
                      <div class="pro_content_li text_start"  v-for="(item,index) in returnVisitPlanList" :key="index">
                        <div class="li_index" @click="planDataInfo(5,item)">{{index+1}}</div>
                        <div class="li_info" style="cursor: pointer;" @click="planDataInfo(5,item)">
                          <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                          <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                        </div>
                        <div style="width:20px;position:relative;">
                          <a v-if="(state==0||state==1||state==4||state==5||state==6)&&isEditAuth&&item.status==0"  @click="editPlanData(5,item)"  style="width: 16px;min-height: 20px;position:absolute;right: 0px;cursor: pointer"><img src="../../../public/img/orderInfo2/rewrite.png" style="width: 16px;height: 16px;"></a>
                        </div>
                      </div>
                      <div class="pro_content_li text_start" v-if="returnVisitPlanList.length==0">
                        无
                      </div>
                    </el-row>
                  </el-main>
                </el-container>



              </div>

            </div>
          </div>

        </el-tab-pane>
        <!-- 2.查看进度 -->
        <el-tab-pane label="查看进度" name="second">
          <div class='page-body' v-if="logs.length!=0">
            <!-- jd_block 为一个整体信息块 -->
            <div class="jd_block" v-for="(item,index) in logs" :key="index">
              <div class="jd_left">
                <div class="jd_date">
                  <div class="left_border">
                    <div class="jd_date_year">{{item.year}}</div>
                    <div class="jd_date_day">{{item.date}}</div>
                  </div>
                </div>
              </div>
              <div class="jd_right" v-if="item.projectLogs">
                <div v-for="(log,_index) in item.projectLogs" :key='_index'>
                  <div v-if="log.type==1">
                    <!-- 普通 -->
                    <!-- jd_r_item 为一个item信息块 -->
                    <div class="jd_r_item mb_20">
                      <!-- <img :src="log.headimgurl?log.headimgurl:workTypeImg.avatar"> -->
                      <img :src="log.avatar?log.avatar:(log.headimgurl?log.headimgurl:workTypeImg.avatar)">
                      <div class="name">{{log.userName}}</div>
                      <div class="type">{{log.content}}</div>
                      <div class="time">{{log.createTime}}</div>
                    </div>
                    <div class="info_text ml_45" v-if="(log.content!='修改排班计划')&&log.contentData">
                      <div style="width: 92%;">{{log.contentData}}</div>
                    </div>
                    <!-- 这个view包裹带有下部内容区域的信息块  -->
                    <!-- <div class="jd_info bg_gary ml_44 pag_all text_limit"
                    v-if="(log.content!='修改排班计划')&&log.contentData">{{log.contentData}}</div> -->
                  </div>
                  <div v-if="log.type==2">
                    <!-- 反馈块 -->
                    <div class="pos_r" style="padding-bottom: 15px;">
                      <div @click="showBtn" class="for-long-btn" :data-index1="index" :data-index2="_index">
                        <div :class='log.isShow?"jd_r_item has-top-to":"jd_r_item has-down-to"' style="flex: 1;">
                          <img :src="log.headimgurl&&log.headimgurl!=null?log.headimgurl:workTypeImg.avatar" />
                          <div class="name">{{log.userName}}</div>
                          <div class="type">{{log.content}}</div>
                          <div class="state">{{log.contentData.flag==0?'未关闭':'已关闭'}}</div>
                          <div class="time">{{log.createTime}}</div>
                        </div>
                        <div style="width: 10px;height: 10px;"></div>
                      </div>
                      <div v-if="log.isShow">
                        <div class="info_text ml_45">
                          <div style="width: 92%;">{{log.contentData.tips}}</div>
                        </div>
                        <div class="ab_text" @click="showcomment2(log)">查看详情</div>
                      </div>
                    </div>
                  </div>

                  <div v-if="log.type==3">
                    <!-- 签到 -->
                    <div @click="showBtn" class="for-long-btn" :data-index1="index" :data-index2="_index">
                      <div :class='log.isShow?"jd_r_item has-top-to":"jd_r_item has-down-to"' style="flex: 1;">
                        <div class="title" style="margin-left: 15px;font-weight: 500;">{{log.content}} </div>
                        <div class="total"><a> 共{{log.contentData.length}}人</a></div>
                        <div class="time">{{log.createTime}}</div>
                      </div>
                      <div style="width: 10px;height: 10px;"></div>
                    </div>
                    <!-- 打卡块 -->
                    <div v-if="log.isShow">
                      <div v-for="(dataItem,_dataIndex) in log.contentData" :key="_dataIndex">
                        <div class="jd_r_item dk mt_16">
                          <img :src="dataItem.start.headimgurl&&dataItem.start.headimgurl!=null?dataItem.start.headimgurl:workTypeImg.avatar" />
                          <div class="name">{{dataItem.start.userName}}</div>
                        </div>
                        <!-- 进场 离场块 -->
                        <div class="jd_info mt_0" style="width: 100%;">
                          <div class="dis_flex">
                            <img class="circle" src="../../../public/img/c_b.png" />
                            <div class="dk_time">进场时间：{{dataItem.start.createTime |filterTime}}</div>
                          </div>
                          <div class="address" v-if="dataItem.start.isForce==1"><a>{{dataItem.start.address}}</a><a>{{dataItem.start.distance}}米</a></div>
                          <div class="dis_flex" v-if="dataItem.stop">
                            <img class="circle" src="../../../public/img/c_y.png" />
                            <div class="dk_time">离场时间：{{dataItem.stop.createTime|filterTime}}</div>
                          </div>
                          <div class="address" v-if="dataItem.stop&&dataItem.stop.isForce==1"><a>{{dataItem.stop.address}}</a><a>{{dataItem.start.distance}}米</a></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="log.type==10">
                    <!-- 设置师傅 -->
                    <div class="pos_r">
                      <div @click="showBtn" class="for-long-btn" :data-index1="index" :data-index2="_index">
                        <div :class='log.isShow?"jd_r_item dk has-top-to":"jd_r_item dk has-down-to"' style="flex: 1;">
                          <img :src="log.headimgurl&&log.headimgurl!=null?log.headimgurl:workTypeImg.avatar" />
                          <div class="name">{{log.userName}}</div>
                          <div class="type">{{log.content}}</div>
                          <div class="time">{{log.createTime}}</div>
                        </div>
                        <div style="width: 10px;height: 10px;"></div>
                      </div>
                      <!-- 师傅列表-->
                      <div class="jd_info mt_0" v-if="log.isShow">
                        <div v-for="(dataItem,_dataIndex) in log.contentData" :key="_dataIndex">
                          <div class="workersList">
                            <div class="ava_img" style="min-width: 70px;" v-for="(item,_dataIndex) in log.contentData" :key="_dataIndex">
                              <div class="workersImg"><img :src="item.headimgurl?item.headimgurl:workTypeImg.avatar" /></div>
                              <div class="ava_name">{{item.userName}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 3.项目反馈 -->
        <el-tab-pane label="项目反馈" name="three">
          <avue-crud :data="record.data.slice((page.currentPage-1)*page.pageSize,page.currentPage*page.pageSize)"
           width="70%" :option="tableOption" @row-click="showRow" :page="page" @current-change="currentChange">
            <template slot-scope="scope" slot="menuLeft">
              <el-button  @click="showcomment" :disabled="showDetail" size="mini" icon="el-icon-view" type="primary">查看详情</el-button>
              <el-button style="margin-left:15px;" @click="addcomment(2)" size="mini" icon="el-icon-circle-plus-outline"
               v-if="state==0 || state==1 || state==4 ||state==5 ||state==6"
              type="primary">添加问题反馈</el-button>
              <el-button style="margin-left:15px;" @click="addcomment(1)" size="mini" icon="el-icon-circle-plus-outline"
                         v-if="state==0 || state==1 || state==4 ||state==5 ||state==6"
                         type="primary">添加日志反馈</el-button>
            </template>
            <template slot-scope="scope" slot="id">
              <el-radio class="radio" v-model="radiorecord" :label="scope.row.id"></el-radio>
            </template>
          </avue-crud>
        </el-tab-pane>
        <!-- 4.费用详情 -->
        <el-tab-pane label="费用详情" name="four" class="four-block">
          <div class="e-top">
            <div class="aside-left">
             费用支出明细({{extracostsObj.length+1}}项)
            </div>
            <div class="aside-right">
            </div>
          </div>
          <div>
            <div class="e-title" style="position: relative;">
              <div v-if="projectInfo.projectType=='安装'" style="flex: 1;">安装费</div>
              <div v-if="projectInfo.projectType=='安装搬运'" style="flex: 1;">安装搬运费</div>
              <div v-if="projectInfo.projectType=='搬运'" style="flex: 1;">搬运费</div>
              <div class="e-price-info">
                <div v-for="(item,index) in projectInfo.workTypes" :key="index">
                  <div>{{item.workTypeName}}{{item.needNum}}人天</div>
                </div>
              </div>
              <div class="p-price" style="padding-right: 24px;">
                <div class="p-yuan">¥</div>
                <div class="fz-36">{{projectInfo.price}}</div>
              </div>
              <div>
                <a v-if="state==0&&isEditAuth" class="rewrite" @click="showpriceDlg" style="top:10px">
                  <img src="../../../public/img/orderInfo2/rewrite.png" style="vertical-align: text-bottom;">
                </a>
              </div>
            </div>

          </div>
          <div class="e-mid" v-for="(item,index) in extracostsObj" :key="index">
            <div class="e-item-top">
              <div class="e-top-left">
                <div class="e-top-type">{{item.priceTypeName}}</div>
                <div class="e-top-tips">{{item.tips}}</div>
              </div>
              <div class="p-price">
                <div class="p-yuan">¥</div>
                <div class="fz-20" style="color: #ff5543;">{{item.price}}</div>
              </div>
            </div>
            <div class="e-item-mid">
             补充费用说明:{{item.companyTips}}
            </div>
            <div class="e-item-mid">
              <div class="e-price-img">
                <div v-for="(citem,index) in item.picPaths" :key="index">
                  <el-image
                    :src="citem"
                    :preview-src-list="item.picPaths"
                    :fit='cover'>
                  </el-image>
                </div>
              </div>
            </div>
            <div class="e-item-bot">
              <div class="e-bot-left">
                支付人：{{item.payeeUserName}}
               <div class="e-sendman">发布人：{{item.createUserName}}</div>
               <div class="e-sendman">{{item.createTime}}</div>
               </div>
              <div class="e-bot-right" @click="showAddInfo(index)">
                <img src="../developed/add.png">
                <div>补充费用说明</div>
              </div>
            </div>
          </div>
          <div style="height: 50px;"></div>
        </el-tab-pane>
      </el-tabs>
      <!-- 底部按钮 -->
      <div class="dialog-footer" v-if="(state==0||state==1||state==2||state==3||state==5||state==-1)&&isEditAuth&&(activeName=='four'||activeName=='first')">
        <el-button class="cancelProject" @click="cancelProject" v-if="state==0||state==1">申请取消项目</el-button>
        <el-button class="refusebtn" @click="refusebtn" v-if="state==5">拒绝结项</el-button>
        <el-button class="agreebtn" @click="agreebtn" v-if="state==5">同意结项</el-button>
        <el-button class="deleteProject" @click="deleteProject" v-if="state==-1 ||state==0 ||state==2 || state==3">删除</el-button>
        <el-button class="againproject" @click="againproject">重新发布</el-button>
        <el-button class="againproject" @click="update" v-if="state==-1">修改</el-button>
      </div>

    </el-dialog>

    <!-- 弹窗部分 -->
    <div class="dlg_block">
      <!-- 0.项目地址联系人编辑-->
      <el-dialog  title="编辑联系人" width="600px" :show-close="showDlgCloseBtn" :visible.sync="xqPageVisable.xmManInfo.isShow">
        <el-input placeholder="请输入姓名" maxlength="10" prefix-icon="el-icon-user-solid" class="myinput" style="margin-top: 20px;"
         :clearable="true" v-model="xqPageVisable.xmManInfo.data.contacts"></el-input>
        <el-input placeholder="请输入手机号" prefix-icon="el-icon-phone" class="myinput"
         :clearable="true" v-model="xqPageVisable.xmManInfo.data.contactPhone" maxlength="11"></el-input>
        <div class="dialog-footer">
          <el-button @click="cancelEditContacts" class="border_gray">取消</el-button>
          <el-button type="primary" @click="updateEditContacts" class="block_blue">确认</el-button>
        </div>
      </el-dialog>
      <!-- 1.附件编辑 -->
      <el-dialog title="编辑附件" width="600px" :show-close="showDlgCloseBtn" @close="fjClose" :visible.sync="xqPageVisable.fJDlg">
        <el-upload ref="uploadWorkFj" :on-success="handleWorkFjSuccess" :auto-upload="false" :action="'/files/fileUpload'|getBaseApiUrl"
          accept="image/*, .pdf, .doc, .docx, .xls, .xlsx" :file-list="filePathsEl" :before-remove="beforeRemove" :on-remove="handleRemove">
          <a class="right_text">上传附件</a>
        </el-upload>
        <div class="dialog-footer">
          <el-button @click="xqPageVisable.fJDlg=false" class="border_gray">取消</el-button>
          <el-button @click="uploadFj" type="primary" class="block_blue">确认</el-button>
        </div>
      </el-dialog>
      <!-- 2.添加协作联系人 -->
      <el-dialog title="添加协作联系人" width="600px" :show-close="showDlgCloseBtn" :visible.sync="xqPageVisable.upxZDlg">
        <a class="right_text" @click="addXz">添加</a>
        <el-input placeholder="工作职责" maxlength="7" prefix-icon="el-icon-menu" class="myinput"
         :clearable="true" v-model="xqPageVisable.upxZDlgData.type"
          prop='type'></el-input>
        <el-input placeholder="请输入姓名" maxlength="10" prefix-icon="el-icon-user-solid" class="myinput"
         :clearable="true" v-model="xqPageVisable.upxZDlgData.name"
          prop='name'></el-input>
        <el-input placeholder="请输入手机号" prefix-icon="el-icon-phone" class="myinput"
         :clearable="true" v-model="xqPageVisable.upxZDlgData.phone"
          prop='phone' maxlength="11"></el-input>
        <div class="dialog-footer">
          <el-button @click="xqPageVisable.upxZDlg=false" class="border_gray">取消</el-button>
          <el-button type="primary" @click="xzAddClick" class="block_blue">确认</el-button>
        </div>
      </el-dialog>
      <!-- 2.协作联系人编辑-->
      <el-dialog title="编辑协作联系人" width="600px" :show-close="showDlgCloseBtn" :visible.sync="xqPageVisable.xZDlg">
<!--        <a class="right_text" @click="addXz">添加</a>-->
    <!--    <el-input placeholder="工作职责" maxlength="7" prefix-icon="el-icon-menu" class="myinput"
         :clearable="true" v-model="xqPageVisable.xZDlgDataInput.type"
          prop='type'></el-input> -->
        <el-input placeholder="请输入姓名" maxlength="10" prefix-icon="el-icon-user-solid" class="myinput" style="margin-top: 20px;"
         :clearable="true" v-model="xqPageVisable.xZDlgDataInput.name"
          prop='name'></el-input>
        <el-input placeholder="请输入手机号" prefix-icon="el-icon-phone" class="myinput"
         :clearable="true" v-model="xqPageVisable.xZDlgDataInput.phone"
          prop='phone' maxlength="11"></el-input>
        <div class="dialog-footer">
          <el-button @click="xzClick" class="border_gray">取消</el-button>
          <el-button type="primary" @click="pushDataToxZDlgData" class="block_blue">确认</el-button>
        </div>
      </el-dialog>
      <!-- 3.备注 -->
      <el-dialog title="编辑备注" width="600px" :show-close="showDlgCloseBtn" :visible.sync="xqPageVisable.bZDlg">
        <textarea class="bz_textarea" style="margin-top: 20px;" type="textarea" placeholder="请输入内容" v-model="describe"></textarea>
        <div class="dialog-footer">
          <el-button @click="bzBackTo" class="border_gray">取消</el-button>
          <el-button @click="updateDescribeSubmit" type="primary" class="block_blue">确认</el-button>
        </div>
      </el-dialog>
      <!-- 4.排班计划 -->
      <el-dialog title="编辑排班计划" width="600px" :show-close="showDlgCloseBtn" :before-close="cancelEdit" :visible.sync="xqPageVisable.pBDlg">
        <a class="right_text_b"><a>{{isOvertime==0?'不加班':'加班'}}</a>
          <el-switch v-model="isOvertime"></el-switch>
        </a>
        <div>
          <div class="pb_input">
            <span>工作时长</span>
            <el-input prefix-icon="el-icon-alarm-clock" @change="durationInput"
              placeholder="输入时长" v-model="duration"></el-input>
          </div>
          <div class="pb_input">
            <span>开工时间</span>
            <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" :picker-options="pickerOptions"
              @change="changeTableDate" suffix-icon="el-icon-circle-close" v-model="startTime">
            </el-date-picker>
          </div>
          <easyTable ref='easyTable' :tableWidth="tableWidth" :tableData="workTypeTable" :workTypeDict="workTypeDict" @getSonTable='getSonTable'></easyTable>
        </div>
        <div class="dialog-footer">
          <el-button @click="cancelEdit" class="border_gray">取消</el-button>
          <el-button @click="updateWorkTypes" type="primary" class="block_blue">确认</el-button>
        </div>
      </el-dialog>
      <!-- 5.发布方式 -->
      <el-dialog title="编辑发布方式" width="600px" :show-close="showDlgCloseBtn" :visible.sync="xqPageVisable.fBDlg">
        <div class="my_flex" style="margin-top: 20px;">
          <!-- 需求大厅发布 -->
          <el-col :class='publishingMode.type==1? "pro_col_item_checked span_width":"pro_col_item span_width"' :span="6">
            <div @click="selectPublishingMode" data-type='1'>
              <el-row class="pro_sendWays_btnImg_checked" justify="space-around">
                <el-col :span="12" class="pro_sendWays_img"><img src="../../../public/img/addProject/qwfb.png"></el-col>
                <el-col :span="12" class="pro_sendWays_btncheck">
                  <img :src='publishingMode.type==1?workTypeImg.isSelected:workTypeImg.unSelected'>
                </el-col>
              </el-row>
              <div class="pro_sendWays_row">
                <p class="pro_sendWays_title">需求大厅发布</p>
                <p class="pro_sendWays_tips">全网发布，所有工种的师傅都能看到</p>
              </div>
            </div>

          </el-col>
          <!-- 群组发布 -->
          <el-col :class='publishingMode.type==2? "pro_col_item_checked span_width":"pro_col_item span_width"' :span="6">
            <div @click="selectPublishingMode" data-type='2'>
              <el-row class="pro_sendWays_btnImg_checked" justify="space-around">
                <el-col :span="12" class="pro_sendWays_img"><img src="../../../public/img/addProject/qzfb.png"></el-col>
                <el-col :span="12" class="pro_sendWays_btncheck"><img :src='publishingMode.type==2?workTypeImg.isSelected:workTypeImg.unSelected'></el-col>
              </el-row>
              <div class="pro_sendWays_row">
                <p class="pro_sendWays_title">群组发布</p>
                <p class="pro_sendWays_tips">发布给本企业的师傅群组</p>
              </div>
            </div>
          </el-col>
          <!-- 师傅发布 -->
          <el-col :class='publishingMode.type==3? "pro_col_item_checked span_width":"pro_col_item span_width"' :span="6">
            <div @click="selectPublishingMode" data-type='3'>
              <el-row class="pro_sendWays_btnImg_checked" justify="space-around">
                <el-col :span="12" class="pro_sendWays_img"><img src="../../../public/img/addProject/sffb.png"></el-col>
                <el-col :span="12" class="pro_sendWays_btncheck"><img :src='publishingMode.type==3?workTypeImg.isSelected:workTypeImg.unSelected'></el-col>
              </el-row>
              <div class="pro_sendWays_row">
                <p class="pro_sendWays_title">师傅发布</p>
                <p class="pro_sendWays_tips">发布给本企业的指定师傅</p>
              </div>
            </div>
          </el-col>
        </div>
        <div class=" group_list_h">
          <div class="man_list">
            <div class="ava_img"
            v-for="(item,index) in (publishingMode.type==3?inviteWorkers:publishingMode.type==2?inviteGroups:[])"
            :key="index">
              <div><img :src="item.headimgurl?item.headimgurl:workTypeImg.avatar"/></div>
              <div class="ava_name">{{publishingMode.type==3?(item.userName?item.userName:item.name):item.groupName}}</div>
            </div>
          </div>
        </div>
        <div class="dialog-footer">
          <el-button class="border_gray" @click="xqPageVisable.fBDlg=false">取消</el-button>
          <el-button type="primary" @click="publicproject" class="block_blue">确认</el-button>
        </div>
      </el-dialog>
      <!-- 6.修改金额 -->
      <el-dialog title="修改金额" width="600px" :show-close="showDlgCloseBtn" :visible.sync="xqPageVisable.jeDlg">
        <!-- <textarea class="bz_textarea" type="textarea" placeholder="请输入金额" v-model="describe"></textarea> -->

        <el-form
        ref="refFormData"
        :rules="rules"
        :model="changeForm"
        label-width="120px"
        class="height-36"
      >
        <el-form-item label="项目金额" prop="allPrice">
          <el-input
            ref="allPrice"
            v-model="changeForm.allPrice"
            placeholder="请输入项目金额"
            clearable
            @blur="_formatAmount"
          />
        </el-form-item>
        <div class="dialog-footer">
          <el-button @click="xqPageVisable.jeDlg=false" class="border_gray">取消</el-button>
          <el-button @click="updatePrice" type="primary" class="block_blue">确认</el-button>
        </div>
      </el-form>

        <!-- 项目金额：<el-input type="tel" v-model="allPrice" placeholder="请输入项目金额"></el-input>
        <div class="dialog-footer">
          <el-button @click="xqPageVisable.jeDlg=false" class="border_gray">取消</el-button>
          <el-button @click="updatePrice" type="primary" class="block_blue">确认</el-button>
        </div> -->
      </el-dialog>
      <!--师傅群组-->
      <el-dialog title="师傅群组" :visible.sync="workerGroupVisible">
        <avue-crud :data="workerGroupData" :option="tableoptionqz" ref="groupCrud" @search-change="searchChangeqz"
         @row-click="workerGroupchange" @select="workerGroupchange" @selection-change='workerGroupchange'></avue-crud>
        <div slot="footer" class="dialog-footer p-38">
          <el-button @click="workerGroupVisible = false">取消</el-button>
          <el-button @click="workerGroupTrue">确定</el-button>
        </div>
      </el-dialog>
      <!--师傅-->
      <el-dialog title="师傅列表" :visible.sync="workerVisible">
        <avue-crud :data="workerData" :option="tableoptionwork" ref="workerCrud"
         @search-change="searchChangegr" @row-click="workSelectionChange"
         @select="workSelectionChange" @selection-change='workSelectionChange'></avue-crud>
        <div slot="footer" class="dialog-footer p-38">
          <el-button @click="workerVisible = false">取消</el-button>
          <el-button @click="workerTrue">确定</el-button>
        </div>
      </el-dialog>
      <!--项目相关人-->
      <el-dialog title="项目相关人" :visible.sync="projectManVisible" append-to-body>
        <avue-crud
          ref="userCrud"
          :data="comworkerData"
          :option="stakeholderOption"
          @refresh-change="searchChangexgr"
          @search-change="searchChangexgr"
          @row-click="selectionChange"
          @select="selectionChange"
          @selection-change="selectionChange"
        >
          <template slot="search">
            <el-form-item label="关键字">
              <el-input v-model="search.conditions"></el-input>
            </el-form-item>
          </template>
        </avue-crud>
        <div slot="footer" class="dialog-footer p-38">
          <el-button @click="projectManVisible = false">取消</el-button>
          <el-button @click="chooseTrue">确定</el-button>
        </div>
      </el-dialog>
      <!-- 7.修改额外费用补充说明 -->
      <el-dialog title="额外费用补充说明" width="600px" :show-close="showDlgCloseBtn" :visible.sync="xqPageVisable.smDlg">
        <div>费用类型: <span>{{extracostsObjSelect.priceTypeName}}</span></div>
        <div>费用说明: <span>{{extracostsObjSelect.tips}}</span></div>
        <div>
          图片:
          <div class="e-item-mid">
            <div class="e-price-img">
              <div v-for="(item,index) in extracostsObjSelect.picPaths" :key="index">
                <div><img :src="item"/></div>
              </div>
            </div>
          </div>
        </div>
        <div>金额: <span>{{extracostsObjSelect.price}}元</span></div>
        <div>支付人: <span>{{extracostsObjSelect.payeeUserName}}</span></div>
        <div>额外费用补充说明: <el-input type="text" v-model="companyInfo" placeholder="请输入补充说明"></el-input></div>
        <div class="dialog-footer">
          <el-button @click="xqPageVisable.smDlg=false" class="border_gray">取消</el-button>
          <el-button @click="updateAddInfo" type="primary" class="block_blue">确认</el-button>
        </div>
      </el-dialog>
      <!-- 6.修改项目工期与时间 -->
      <el-dialog title="修改计划工期" width="600px" :show-close="showDlgCloseBtn" :visible.sync="xqPageVisable.planDateDlg">
        <el-form
          ref="planDateForm"
          :rules="rules"
          :model="planDateForm"
          label-width="120px"
          class="height-36"
        >
          <el-form-item label="预计工期" prop="duration">
            <el-input
              ref="allPrice"
              v-model="planDateForm.duration"
              placeholder="请输入预计工期"
              clearable
              type="number"
            />
          </el-form-item>
          <el-form-item label="开始时间" prop="startTime">
            <el-date-picker class="pro_workTime" v-model="planDateForm.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm"
                            placeholder="选择日期" :picker-options="pickerOptions0" @change="changeTableDate">
            </el-date-picker>
          </el-form-item>
          <div class="dialog-footer">
            <el-button @click="xqPageVisable.planDateDlg=false" class="border_gray">取消</el-button>
            <el-button @click="updatePlanDate" type="primary" class="block_blue">确认</el-button>
          </div>
        </el-form>

      </el-dialog>




    </div>

    <!--拒绝结项-->
    <refuse ref="child3" @refresh="refresh"></refuse>
    <!--添加反馈-->
    <insertrecord ref="childinsert" @refreshcord="refreshcord"></insertrecord>
    <!--展示结项图片-->
    <showReport ref="imgchild"></showReport>
    <!--查看视频-->
    <videolist ref="childvideo"></videolist>
    <!--查看反馈信息-->
    <!-- <comment ref="childcomment"></comment> -->
    <comment2 ref="childcomment" @func='refreshFeedBackList'></comment2>
    <!-- 查看工作内容 -->
    <contentInfo ref="contentInfo"></contentInfo>

    <!-- 编辑勘查、验收、回访计划内容 -->
    <editBasePlan ref="editBasePlan" :type-name="typeName" @setContent="updatePlanData"></editBasePlan>
    <editDaohuoPlan ref="editDaohuoPlan"  @setContent="updatePlanData"></editDaohuoPlan>
    <editInstallPlan ref="editInstallPlan"  @setContent="updatePlanData"></editInstallPlan>

    <!-- 查看勘查、验收、回访计划内容 -->
    <basePlanInfo ref="basePlanInfo"></basePlanInfo>
    <daohuoPlanInfo ref="daohuoPlanInfo"></daohuoPlanInfo>
    <installPlanInfo ref="installPlanInfo"></installPlanInfo>

  </div>
</template>
<script>
  import {
    getProjectInfo,
    getReport,
    deletOrder,
    agree,
    getProgInfo,
    getFeedbacks,
    updateDescribe,
    updateFilePaths,
    updateWorkTypes,
    updateProjectChannel,
    updateAddressContact,
    updateRelevantContacts
  } from "@/api/admin/taskManagement";

  import {
    updateProjectPrice,
    updateProjectExtraCostsCompanyTips
  } from "@/api/admin/financeManagement";
  import {
    updateProjectPlanDate,
    insertOrUpdateProjectPlanProspecting,
    insertOrUpdateProjectPlanDaohuo,
    insertOrUpdateProjectPlanInstallation,
    insertOrUpdateProjectPlanArrival,
    insertOrUpdateProjectPlanReturnvisit,
    delPlan
  } from "@/api/admin/projectPlan";
  import {
    getWorkerInfo,
    updateStakeholders
  } from "@/api/admin/business";
  import {
    personnelget1,
    groupqz
  } from "@/const/asset/user";
  import {
    getImgLink,
    apiLink
  } from "@/config/env";
  import {
    dateOnce
  } from "@/util/dateT";
  import {
    dateSplit,
    dateY
  } from "@/util/date";
  import {
    objKeySort
  } from "@/util/ajaxsign";
  import {
    getProjectContents,
    getGroupList,
    getWorkerList,
    getProjectExtraCosts
  } from "@/api/admin/addProject";
  import {
    dealElement,
    matchType,
    checkPhone,
    toFixed2
  } from "@/util/util";
  import {
    getDictList
  } from "@/api/admin/dict";
  import {
    fetchList
  } from "@/api/admin/groups";
  import record from "./record.vue";
  import refuse from "./refuse.vue";
  import insertrecord from "./insertrecord.vue";
  import showReport from "./showimg.vue";
  import videolist from "./video.vue";
  import comment from "./comment.vue";
  import comment2 from "./comment2.vue";
  import contentInfo from "./contentInfo.vue";
  import myAvatar from "./components/myAvatar.vue";
  import myWorkContentList from "./components/myWorkContentList.vue";
  import myWorkFj from "./components/myWorkFj.vue";
  import myPicList from "./components/myPicList.vue";
  import easyTable from "../common/easytable.vue";
  import myTable from "./components/myTable.vue";
  import sendWays from "./components/sendWays.vue";
  import editBasePlan from "./planComponents/editBasePlan.vue";
  import editDaohuoPlan from "./planComponents/editDaohuoPlan.vue";
  import editInstallPlan from "./planComponents/editInstallPlan.vue";
  import basePlanInfo from "./planComponents/basePlanInfo.vue";
  import daohuoPlanInfo from "./planComponents/daohuoPlanInfo.vue";
  import installPlanInfo from "./planComponents/installPlanInfo.vue";
  import '../../styles/common.scss'
  import '../../styles/orderInfo2.scss'
  import '../../styles/addProject.scss'
  import {
    dataday
  } from '@/util/dateT'
  import {
    getDateStr
  } from '@/util/date'

  export default {

    data() {
      return {
        userInfo:[],
        dialogFormVisible: false,
        projectManVisible: false,
        cancelStateus: true,
        statecancel: true,
        recordflag: false, //查看日志
        activeName: "first",
        ownStakeholders: [],
        ownWorker:[],//已选择的师傅
        ownGroup:[],//已选择的群组
        logs: [],
        comworkerData: [],
        stakeholderOption: personnelget1,
        radiouser: "",
        index: "", //选中的地址下标
        getReports: [], //验收报告
        refuse: [],
        stakeholders: [], // 项目相关人
        stakeholderIds:'',//已选择的相关人
        foremanInfo: [], //应招师傅
        filePaths: [], //项目附件
        isOpen: 0, //是否发布到需求大厅
        inviteWorkers: [], //发布渠道选择的师傅
        inviteGroups: [], //发布渠道选择的群组
        works: [], //参与师傅
        workerGrouptagsArr:[],//选择的群组tags
        projectInfo:{},//项目信息
        projectData: {},
        projectName: "",
        projectId: "", //项目id号
        // orderinfo: "",
        address: "", //项目地址信息
        startTime: "", //项目开始时间
        startTimeTemp: "", //项目开始时间 暂存
        duration: "", //工作时长
        durationTemp:'',//工作时长暂存
        isOvertime: "", //是否加班
        workTypes: [], //需求工种
        domains: [], //工作内容
        isEditAuth: false, //是否可以编辑项目信息
        showDetail:true,//是否可以点击查看反馈
        refuseLog:[],//拒绝结项原因
        companyId:'',
        companyState:0,//企业认证状态
        extracostsObjSelect:{},//选择的额外费用
        companyInfo:'',//输入的 额外费用说明
        prospecting:[],    //勘查
        daohuoPlanList:[],  //到货
        installationPlanList:[], //安装
        arrivalPlanList:[],   //验收
        returnVisitPlanList:[], //回访
        record:{
          data: [],
          pageSize: 9,
          currentPage: 1
        },
        search: {},
        state: "",
        radiorecord: "",
        serviceType: "",
        recordStatus: "",
        companyName: "",
        userName: "",
        creatUserInfo:{
          avatar:'',
          headimgurl:''
        },//项目发布人信息
        imgstate: "",
        workerData: [],//师傅列表数据
        contentShowNum: {
          data: 10,
          isMore: false
        }, //默认显示10条数据
        filePathsEl: [], //附件数组 用于el结构
        describe: '', //备注
        workTypeTable: [], //工作排班表格
        workTypeTableTemp:[],//备份表格数据,用于取消修改时恢复
        tableArr: [], //格式化排班表格数据
        page: {
          pageSizes: [10, 20, 50, 100],
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        createTime: "",
        tableData: [],
        relevantContacts: [], //协作联系人
        tableWidth: { //设置不同页面的tr th 宽度
          th: '144.5',
          td: '98',
          isEdit: true
        },
        picPaths:[],
        cover:'scale-down',//图片模式
        extracostsObj:[],
        showExtraCosts:false,
        extracostsPriceSum:0,
        bzInput: '', //备注信息
        keyword: '', //搜索关键字
        showDlgCloseBtn: false, //隐藏 dialog的关闭小按钮
        xqPageVisable: { //详情页的弹窗显示控制
          fJDlg: false, //附件
          xZDlg: false, //协作联系人
          upxZDlg: false, //添加协作人
          bZDlg: false, //备注
          pBDlg: false, //排班
          fBDlg: false, //发布方式
          jeDlg:false,//项目金额
          planDateDlg:false,  //项目工期
          basePlanDlg:false,  //标准计划
          daohuoPlanDlg:false,  //到货计划
          installPlanDlg:false,  //安装计划
          xZDlgData: '', //协作联系人数据
          xZDlgDataInput: '', //协作联系人数据输入
          smDlg:false,//说明弹窗
          upxZDlgData: {
            type: '',
            name: '',
            phone: ''
          }, //添加协作人数据
          xmManInfo: { //项目地址联系人编辑
            isShow: false,
            data: {
              contacts: '',
              contactPhone: ''
            },
            index: ''
          }
        },
        changeForm:{
          allPrice:'',//项目金额
        },
        planDateForm:{
          duration:"",
          startTime:""
        },
        planTypeName:"",
        rules:{
          allPrice:[
          {
            required: true,
            message: "请输入项目金额",
            trigger: "blur"
          },
          {
            pattern: /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[0-9][0-9]*\.\d{1,2})))$/,
            message: "仅能输入非负数字、小数点且小数点后为2位",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (999999 >= value.toString().split(".")[0]) {
                callback();
              } else {
                callback(new Error("输入的金额超出限定值"));
              }
            },
            trigger: "blur"
          }
        ]
        },
        // 工种类型及数量
        workTypeDict: [{
            id: '1',
            name: '搬运工',
            code: 'by',
            needNum: 0
          },
          {
            id: '2',
            name: '安装工',
            code: 'az',
            needNum: 0
          },
          {
            id: '3',
            name: '补漆工',
            code: 'bq',
            needNum: 0
          },
          {
            id: '4',
            name: '维修工',
            code: 'wx',
            needNum: 0
          }
        ],
        publishingMode: { //发布方式
           type: 0,
          workers: []
        },
        workerGroupVisible: false, // 师傅群组弹框
        workerGroupData: [], //师傅群组数据
        workerVisible: false, //师傅弹窗
        workTypeImg: {
          isSelected: require('../../../public/img/addProject/checked.png'),
          unSelected: require('../../../public/img/addProject/unchecked.png'),
          avatar:require('../../../public/img/addProject/default-avatar.png')
        },
        dic: [], //师傅表格数据
        // 时间选择范围
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() <= new Date().getTime() - 86400000;
          }
        },
        // isShowDetail:false,
        tableoptionqz: groupqz,
        tableoptionwork: {
          addBtn: false,
          selection: true,
          refreshBtn: false,
          editBtn: false,
          delBtn: false,
          menu: false,
          columnBtn: true,
          header: true,
          headerMenu: false,
          page: true,
          border: true,
          searchLabelWidth: "80",
          search: {
            prop: "condition",
            label: "师傅信息",
            searchPlaceholder: "请输入关键字"
          },
          align: "center",
          menuAlign: "center",
          height: window.innerHeight - 230,
          index: false,
          column: [{
              label: "手机号码",
              prop: "phone",
              overHidden: true
            },
            {
              label: "姓名",
              prop: "name",
              overHidden: true
            },
            {
              label: "团队认证",
              prop: "isForeman",
              search: true,
              type: "select",
              dicData: [{
                  label: "已认证",
                  value: 1
                },
                {
                  label: "未认证",
                  value: 0
                }
              ],
              overHidden: true,
              formatter: function(row) {
                return row.isForeman == 1 ? "已认证" : "未认证";
              }
            },
            {
              label: "工种",
              prop: "workTypeIds",
              type: "select",
              dicData: {},
              props: {
                label: "name",
                value: "id"
              },
              search: true,
              overHidden: true
            },
            {
              label: "实名状态",
              prop: "workerState",
              formatter: function(row) {
                if (row.workerState == 1) {
                  return "审核中";
                } else if (row.workerState == 2) {
                  return "已认证";
                } else {
                  return "未认证";
                }
              }
            },
            {
              label: "群组",
              prop: "groupNames",
              overHidden: true,
              type: "select",
              props: {
                label: "groupName",
                value: "id"
              },
              search: true
            }
          ]
        },
        // 项目反馈表格数据
        tableOption: {
          addBtn: false,
          refreshBtn: false,
          columnBtn: true,
          editBtn: true,
          delBtn: true,
          menu: false,
          page: true,
          border: true,
          align: "center",
          menuAlign: "center",
          height: window.innerHeight - 450,
          serviceType: "",
          index: false,
          column: [{
              label: "",
              prop: "id",
              width: 40,
              solt: true
            },
            {
              label: "反馈类型",
              prop: "type",
              formatter: function(row) {
                return row.type == 1 ? "日志反馈" : "问题反馈";
              }
            },
            {
              label: "反馈人",
              prop: "userName"
            },
            {
              label: "问题是否解决",
              prop: "flag",
              formatter: function(row) {
                return row.type== 1? "-":row.flag == 1 ? "已解决" : "未解决";
              }
            },
            {
              label: "内容信息",
              prop: "tips",
              overHidden: true,
              formatter: function(row) {
                return row.tips.split("times")[0];
              }
            },
            {
              label: "查看(次)",
              prop: "viewNum"
            },
            {
              label: "评论(次)",
              prop: "commentNum"
            },
            {
              label: "创建时间",
              prop: "createTime",
              overHidden: true,
              type: "date",
              format: "yyyy-MM-dd HH:mm:ss",
              valueFormat: "yyyy-MM-dd HH:mm:ss"
            }
          ]
        }
      };
    },
    created() {},
    mounted() {
      this.initDic();
    },
    filters: {
      getBaseImgUrl: function(uri) {
        console.log(uri);
        if (uri) {
          return getImgLink(uri);
        } else {
          return "";
        }
      },
      getBaseApiUrl: function(uri) {
        if (uri) {
          return apiLink(uri);
        } else {
          return "";
        }
      },
      filterTime: function(time) {
        let date = new Date(time);
        let year = date.getFullYear();
        let month = date.getMonth() > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
        let day = date.getDate() > 9 ? date.getDate()  : `0${date.getDate()}`;
        let hour= date.getHours()>9?date.getHours()  : `0${date.getHours()}`;
        let min= date.getMinutes()>9?date.getMinutes()  : `0${date.getMinutes()}`;
        let ss= date.getSeconds()>9?date.getSeconds()  : `0${date.getSeconds()}`;
        return `${year}-${month}-${day} ${hour}:${min}:${ss}`;
      },
    },
    methods: {
      // ----------------------------------项目地址的联系人修改操作
      // 联系人修改窗
      showContactsDlg(item, index) {
        let that = this
        that.xqPageVisable.xmManInfo.isShow = true
        that.xqPageVisable.xmManInfo.data = JSON.parse(JSON.stringify(item));
        //记录修改的联系人人 下标 用于以后数据的修改
        that.xqPageVisable.xmManInfo.data.index = index;
      },
      // 取消修改 地址联系人
      cancelEditContacts() {
        let that = this
        that.xqPageVisable.xmManInfo.isShow = false //关闭地址联系人dlg
      },
      // 确认修改 地址联系人
      updateEditContacts() {
        let that = this
        if (that.xqPageVisable.xmManInfo.data.contacts != '' && checkPhone(that.xqPageVisable.xmManInfo.data.contactPhone)) {
          that.xqPageVisable.xmManInfo.data = {
            contacts: that.xqPageVisable.xmManInfo.data.contacts,
            contactPhone: that.xqPageVisable.xmManInfo.data.contactPhone
          }
          //替换原有的数据
          that.address.forEach((item, index) => {
            if (index == that.xqPageVisable.xmManInfo.index) {
              item.contacts = that.xqPageVisable.xmManInfo.data.contacts,
                item.contactPhone = that.xqPageVisable.xmManInfo.data.contactPhone
              //提交数据
              that.updateContactSubmit(item, 1)
            }
            that.xqPageVisable.xmManInfo.isShow = false //关闭地址联系人 dlg
            return
          })
        } else {
          that.$alert('您输入的信息有误或不完整', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        }
      },
      // ------------------------------------------------工作内容操作
      //展示更多的内容条数
      showMore() {
        let that = this
        if (that.contentShowNum.isMore == false) {
          that.contentShowNum.data = that.domains.length
        } else {
          that.contentShowNum.data = 10
        }
        that.contentShowNum.isMore ? that.contentShowNum.isMore = false : that.contentShowNum.isMore = true
      },
      //搜索
      searchWorkContent() {
        var that = this
        that.getData()
      },
      //获取搜索数据
      getData() {
        let that = this;
        that.isShowSearch=false;
        getProjectContents(objKeySort({
          projectId: that.projectId,
          condition: that.keyword,
        })).then(response => {
          var contents = [];
          response.data.data.forEach(content => {
            // var firstImg = '';
            var imgNum = 0;
            var vidNum = 0;
            let imgPaths = content.imgPaths ? content.imgPaths.split(',') : [];
            let voicePaths = content.voicePaths ? content.voicePaths.split(',') : [];
            if (imgPaths && imgPaths.length > 0) {
              imgNum = imgPaths.length;
              // firstImg = imgPaths[0];
            }
            if (voicePaths && voicePaths.length > 0) {
              vidNum = voicePaths.length
            }
            contents.push({
              tips: content.tips,
              // firstImg:firstImg?that.data.baseFileUrl+firstImg:'',
              imgNum: imgNum,
              vidNum: vidNum,
              contentId: content.contentId
            })
          })
          that.domains = contents
        })
      },

      //取消修改备注
      bzBackTo() {
        let that = this
        that.describe = that.bzInput
        that.xqPageVisable.bZDlg = false
      },
      //提交修改备注
      updateDescribeSubmit() {
        let that = this
        let mdata = {
          projectId: that.projectId,
          describe: that.describe
        }
        updateDescribe(objKeySort(mdata)).then(response => {
          if (response.data.code == 200) {
            that.$message({
              type: 'success',
              message: '修改成功'
            })
            that.xqPageVisable.bZDlg = false
          }
        })
      },
      // -----------------------------------------------附件操作
      //上传的附件添加到列表中
      handleWorkFjSuccess(res) {
        if (res.code == 200) {
          let that = this
          that.filePathsEl = that.filePathsEl.concat(that.changeToel(res.data))
          let filePaths = [];
          that.filePathsEl.forEach(item=>{
            let filePath={
              name:item.name,
              url:item.url
            }
            filePaths.push(filePath);
          })
          console.log(filePaths)
          let mdata = {
            projectId: that.projectId,
            filePaths: JSON.stringify(filePaths)
          }
          updateFilePaths(objKeySort(mdata)).then(obj=>{
            if(obj.data.code==200){
              that.$message({
                type:'success',
                message:'修改成功'
              })
            that.xqPageVisable.fJDlg = false
            }else{
              that.$message({
                type:'warning',
                message:obj.data.msg
              })
            }
          })
        }
      },
      // 上传附件
      uploadFj() {
        let that = this
        that.$refs.uploadWorkFj.submit();
      },
      beforeRemove(file){
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      //监听 附件移除
      handleRemove(file) {
        let that = this
        that.filePathsEl.forEach((item, index) => {
          if (file.uid == item.uid) {
            that.filePathsEl.splice(index, 1)
            this.$message({
              title: '成功',
              message: '成功删除附件',
              type: 'success',
              duration: 2000
            })
          }
        })
      },
      // --------------------------------------------------协作人操作
      //添加 协作人
      addXz() {
        let that = this
        that.xqPageVisable.xZDlg = false
        that.xqPageVisable.upxZDlg = true
      },
      //协作人 修改 弹出协作人dlg
      isShowXzDlg(value, index) {
        let that = this
        that.xqPageVisable.xZDlg = true
        that.xqPageVisable.xZDlgDataInput = JSON.parse(JSON.stringify(value));
        //记录修改的协作人 下标 用于以后数据的修改
        that.xqPageVisable.xZDlgDataInput.index = index;
      },
      //协作人 取消
      xzClick() {
        let that = this
        that.xqPageVisable.xZDlg = false //关闭协作人dlg
        that.xqPageVisable.upxZDlg = false //关闭添加协作人dlg
      },
      //把修改后的数提交给xZDlgData
      pushDataToxZDlgData() {
        let that = this
        if (that.xqPageVisable.xZDlgDataInput.name != '' && that.xqPageVisable.xZDlgDataInput.type != '' && checkPhone(that.xqPageVisable
          .xZDlgDataInput.phone)) {
          that.xqPageVisable.xZDlgData = {
            name: that.xqPageVisable.xZDlgDataInput.name,
            type: that.xqPageVisable.xZDlgDataInput.type,
            phone: that.xqPageVisable.xZDlgDataInput.phone
          }
          //替换原有的数据
          that.relevantContacts.splice(that.xqPageVisable.xZDlgDataInput.index, 1, that.xqPageVisable.xZDlgData)
          // 数据提交后台
          that.updateContactSubmit('', 2)
          //把修改后的数据提交
          that.xqPageVisable.xZDlg = false //关闭协作人dlg
        } else {
          that.$alert('您输入的信息有误或不完整', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        }
      },
      //添加协作人
      xzAddClick() {
        let that = this
        //判断输入信息
        if (that.xqPageVisable.upxZDlgData.name != '' && that.xqPageVisable.upxZDlgData.type != '' &&  checkPhone(that.xqPageVisable
          .upxZDlgData.phone)) {
          that.xqPageVisable.upxZDlgData = {
            name: that.xqPageVisable.upxZDlgData.name,
            type: that.xqPageVisable.upxZDlgData.type,
            phone: that.xqPageVisable.upxZDlgData.phone
          }
          that.relevantContacts.push(that.xqPageVisable.upxZDlgData)
          //提交数据
          that.updateContactSubmit('', 2)
          that.xqPageVisable.upxZDlg = false
        } else {
          that.$alert('您输入的信息有误或不完整', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        }
      },
      //----------------------------------------------提交修改联系人的数据
      updateContactSubmit: function(obj, type) {
        let that = this;
        if (type == 1) { //更新项目地址联系人
          let mdata = {
            addressId: obj.addressId,
            contacts: obj.contacts,
            contactPhone: obj.contactPhone
          }
          updateAddressContact(objKeySort(mdata)).then(response => {
            if (response.data.code == 200) {
              that.$message({
                type: 'success',
                message: '修改成功'
              })
            }
          })
        } else if (type == 2) { //更新原有协作联系人
          let mdata = {
            projectId: that.projectId,
            relevantContacts: JSON.stringify(that.relevantContacts)
          }
          updateRelevantContacts(objKeySort(mdata)).then(response => {
            if (response.data.code == 200) {
              that.$message({
                type: 'success',
                message: '修改成功'
              })
            }
          })
        }
      },

      // ---------------------------------------------修改表格操作
      //初始化easytable 排班计划表 1第一次进入初始化  2修改数据  3    4不需要经过修改需求工种方法
      initTypeTable: function(type) {
        return;
        let that = this;
        if (that.duration <= 0) {
          return
        }
        var _workTypeTable = that.workTypeTable;
        if (!_workTypeTable) {
          _workTypeTable = [];
        } else {
          _workTypeTable.splice(that.duration, _workTypeTable.length);
        }
        for (var i = 0; i < that.duration; i++) {
          if (!_workTypeTable[i]) { //初始化 对象结构
            _workTypeTable[i] = {
              az: null,
              bq: null,
              by: null,
              workScheduleRuleDate: {
                data: '',
                index: ''
              },
              workTime: "",
              workTypeNum: [{
                code: '1',
                value: '0'
              }, {
                code: '2',
                value: '0'
              }, {
                code: '3',
                value: '0'
              }, {
                code: '4',
                value: '0'
              }],
              wx: null
            }
          }
          if(type==1||type==4){//如果是第一次进入 或者修改时间
            _workTypeTable[i]['workTime'] = getDateStr(dataday(that.startTime), i);
          }else if(type==5){
            _workTypeTable[i]['workTime'] = _workTypeTable[i].workScheduleRuleDate.date;
          }
          that.workTypeDict.forEach((dict, index) => {
            if (!_workTypeTable[i][dict.code]) { //如果第一次进入 则无相关属性
              if (_workTypeTable[i].workTypeNum[index].value) { //第一次进入数据判定
                _workTypeTable[i][dict.code] = _workTypeTable[i].workTypeNum[index].value=='-'?0:_workTypeTable[i].workTypeNum[index].value
              } else { //无属性 直接赋值为-
                _workTypeTable[i][dict.code] = 0
              }
            } else {
              _workTypeTable[i][dict.code] = _workTypeTable[i].workTypeNum[index].value == 0 ? 0 :
                _workTypeTable[i].workTypeNum[index].value
            }
          })
        }
        if(type!=4){
          that.getWorkTypeNum(_workTypeTable)
        }
        that.workTypeTable = _workTypeTable;
      },
      //获取工种数量
      getWorkTypeNum(arr) {
        let that = this
        let _workTypeDict=[]
        //修改数据后 更改需求工种数量workTypes  和用于上传的数据workTypeTable
          // 更改 workTypeDict
          _workTypeDict=that.workTypeDict
          let [azNum, byNum, wxNum, bqNum] = [0, 0, 0, 0]
            arr.forEach(item=>{
              byNum += parseInt(item.by == '-' ? 0 : item.by)
              azNum += parseInt(item.az == '-' ? 0 : item.az)
              bqNum += parseInt(item.bq == '-' ? 0 : item.bq)
              wxNum += parseInt(item.wx == '-' ? 0 : item.wx)
          })
          _workTypeDict.forEach(item=>{
            item.code=='by'?(item.needNum=byNum):0
            item.code=='az'?(item.needNum=azNum):0
            item.code=='bq'?(item.needNum=bqNum):0
            item.code=='wx'?(item.needNum=wxNum):0
          })
        that.workTypes = _workTypeDict
      },
      // 修改工作时长 并根据时长修改
      durationInput(value) {
        let that = this
        that.duration = value
        that.initTypeTable(4)
      },
      //选择开工时间
      changeTableDate(e) {
        let that = this
        that.planDateForm.startTime = e
      },
      //接受子组件的传值
      getSonTable(data) {
        let that = this
        //数据是从easytable 改动的
        if(data.isdate){
          if(data.index==0){
            that.workTypeTable[data.index].workTime=data.value
            that.workTypeTable[data.index].workScheduleRuleDate.date =data.value
            //更新时间选择框中的数据
            that.startTime=data.value
          }else{
            that.workTypeTable[data.index].workTime=data.value
            that.workTypeTable[data.index].workScheduleRuleDate.date =data.value
          }
        }else{
         data.forEach((item, i) => {
           data[i].workTypeNum[0].value = data[i].by
           data[i].workTypeNum[1].value = data[i].az
           data[i].workTypeNum[2].value = data[i].bq
           data[i].workTypeNum[3].value = data[i].wx
         })
         //更新workTypes 用于上传数据
         that.workTypeTable = data
        }
      },
      //格式化表格数据
      initTableData(data) {
        let that = this
        that.tableArr = []
        if (data) {
          data.forEach((item) => {
            let tableItem = {}
            tableItem.date = item.workScheduleRuleDate.date?item.workScheduleRuleDate.date:item.workTime
            item.workTypeNum.forEach((citem) => {
              switch (citem.code) {
                case '1':
                  tableItem.by = (citem.value == 0 ? '0' : citem.value);
                  break;
                case '2':
                  tableItem.az = (citem.value == 0 ? '0' : citem.value);
                  break;
                case '3':
                  tableItem.bq = (citem.value == 0 ? '0' : citem.value);
                  break;
                case '4':
                  tableItem.wx = (citem.value == 0 ? '0' : citem.value);
                  break;
                default:
                  break;
              }
            })
            that.tableArr.push(tableItem);
          })
        }

      },
      cellStyle({row, column}){
        if (row.az>0&&column.property=='az'){
          return {background: 'rgba(237,239,242,1)',color:'#000'};
        }
        if (row.by>0&&column.property=='by'){
          return {background: 'rgba(237,239,242,1)',color:'#000'};
        }
        if (row.wx>0&&column.property=='wx'){
          return {background: 'rgba(237,239,242,1)',color:'#000'};
        }
        if (row.bq>0&&column.property=='bq'){
          return {background: 'rgba(237,239,242,1)',color:'#000'};
        }
      },
      //取消 修改
      cancelEdit(){
        let that = this
        that.xqPageVisable.pBDlg=false
        that.duration=that.durationTemp;
        that.startTime=that.startTimeTemp;
        let _workTypeTableTemp=that.workTypeTableTemp;
        let _workTypeTable=that.workTypeTable;
        _workTypeTableTemp.forEach((itemTemp,indexTemp)=>{
          _workTypeTable.forEach((item,index)=>{
            if(indexTemp==index){
              item['workTime']=itemTemp.workScheduleRuleDate.date;
              item.workScheduleRuleDate.date=itemTemp.workScheduleRuleDate.date;
            }
          })
        })
      },
      //提交更新的表格数据
      updateWorkTypes() {
        let that = this;
        //更新workerTypes
        that.initTypeTable(2)
        //更新workTypeTableTemp 用于取消修改时 数据还原
        that.workTypeTableTemp=JSON.parse(JSON.stringify(that.workTypeTable))
        //更新workTypeTable
        that.workTypeTable.forEach(item=>{
          item.workScheduleRuleDate.date=item.workTime
          //删除workTime by az bq wx字段
          delete item['workTime'];
          delete item['by'];
          delete item['az'];
          delete item['bq'];
          delete item['wx'];
        })

        //重组 workerTypes
        let _workTypes=JSON.parse(JSON.stringify(that.workTypes))
        var keyMap = {id: 'workTypeCode', name: 'workTypeName'}
        for(var i = 0;i < _workTypes.length;i++){
          delete _workTypes[i]['code']
          var obj = _workTypes[i];
          for(var key in obj){
           var newKey = keyMap[key];
           if(newKey){
            obj[newKey] = obj[key];
            delete obj[key];
           }
          }
        }

        let mdata = {
          projectId: that.projectId,
          duration: that.duration,
          isWorkOvertime: that.isOvertime ? 1 : 0,
          startDate: that.startTime,
          stopDate: that.workTypeTable[that.workTypeTable.length - 1].workScheduleRuleDate.date,
          workerTypes: JSON.stringify(_workTypes),
          workTypeTable: JSON.stringify(that.workTypeTable)
        }

        that.durationTemp=that.duration
        that.startTimeTemp=that.startTime
        updateWorkTypes(objKeySort(mdata)).then(response => {
          console.log(response.data)
          that.xqPageVisable.pBDlg = false
          that.initTableData(that.workTypeTable)
        })
      },

      //-------------------------------------------------------选择发布方式
      //选择发布方式
      selectPublishingMode(e) {
        let that = this;
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        that.companyState = userInfo.company.state;
        if (e.currentTarget.dataset.type == 1) {
          //判断是否能进行大厅发布
          if (that.companyState != 2) {
            that.$alert('您的企业还未认证，不能发布到需求大厅', '温馨提示', {
              confirmButtonText: '确定',
            })
            return
          }
          that.publishingMode.type = 1;

        } else if (e.currentTarget.dataset.type == 2) {
          that.workerGroupVisible = true
          that.workerGroup()
          that.publishingMode.type = 2;
        } else if (e.currentTarget.dataset.type == 3) {
          that.workerVisible = true
          that.workerArr()
          that.publishingMode.type = 3;
        }
      },
      // -------------发布方式弹窗操作

      // 我的师傅多选
      workSelectionChange(val) {
        // this.ownWokerTags = val;
        let that=this
        if(Object.prototype.toString.call(val)== '[object Array]'){
          that.ownWorker = val;
        }else{
          // 有勾选的数据
          if(that.ownWorker.length>0){
            // 遍历并判断是否是选择了 已在选择数据中的数据
            that.ownWorker.slice().reverse().forEach((citem, index, object)=>{
              if(citem.id==val.id){
                // 取消已经勾选的
                that.ownWorker.splice(object.length - 1 - index, 1);
                // citem.check=false
                that.$nextTick(() => {
                    that.$refs.workerCrud.toggleRowSelection(val, false);
                });
              }
            })
          }
          if(that.workerData.length>0){
            that.workerData.forEach(item=>{
              if(item.id==val.id&&item.check==true){
                 item.check=false
                 that.$nextTick(() => {
                   that.$refs.workerCrud.toggleRowSelection(item, false);
                 })
              }else if((val.check==undefined||val.check==false)&&item.id==val.id){
                item.check=true
                that.ownWorker.push(item)
                that.$nextTick(() => {
                  that.$refs.workerCrud.toggleRowSelection(item, true);
                })
              }
            })
          }
        }
      },
      // 我的师傅确定选择
      workerTrue() {
        let that=this
        that.workerVisible = false;
        that.publishingMode.worksIds = that.dataFilter(that.ownWorker); //过滤为id
        that.publishingMode.works = that.ownWorker;
        that.publicproject()
      },
      //展示师傅列表
      workerArr() {
        let that = this
          that.ownWorker=[];
          getWorkerList(objKeySort(that.searchgr)).then(response => {
          that.workerData = response.data.data;
          that.workerData.forEach(data => {
            // data.workTypeIds = that.formatterWorkType(data.workTypeIds);
            if(that.inviteWorkers&&that.inviteWorkers.length>0){
              that.inviteWorkers.forEach(item=>{
                if((item.userId?item.userId:item.id)==data.id){
                  data.check=true
                  that.ownWorker.push(data)
                  that.$nextTick(() => {
                    that.$refs.workerCrud.toggleRowSelection(data, true);
                  })
                }
              })
            }
          })
        });
        that.workerVisible = true;
      },
      // 师傅群组确定选择
      workerGroupchange(val) {
        let that=this
        if(Object.prototype.toString.call(val)== '[object Array]'){
          that.ownGroup = val;
        }else{
          // 有勾选的数据
          if(that.ownGroup.length>0){
            // 遍历并判断是否是选择了 已在选择数据中的数据
            that.ownGroup.slice().reverse().forEach((citem, index, object)=>{
              if(citem.id==val.id){
                // 取消已经勾选的
                that.ownGroup.splice(object.length - 1 - index, 1);
                // citem.check=false
                that.$nextTick(() => {
                    that.$refs.groupCrud.toggleRowSelection(val, false);
                });
              }
            })
          }

          if(that.workerGroupData.length>0){
            that.workerGroupData.forEach(item=>{
              if(item.id==val.id&&item.check==true){
                 item.check=false
                 that.$nextTick(() => {
                   that.$refs.groupCrud.toggleRowSelection(item, false);
                 })
              }else if((val.check==undefined||val.check==false)&&item.id==val.id){
                item.check=true
                that.ownGroup.push(item)
                that.$nextTick(() => {
                  that.$refs.groupCrud.toggleRowSelection(item, true);
                })
              }
            })
          }
        }
        // this.workerGrouptagsArr = val;
      },
      workerGroupTrue() {
        let that=this
        that.workerGroupVisible = false;
        that.publishingMode.groupIds = that.dataFilter(that.ownGroup); //过滤为id
        that.inviteGroups = that.ownGroup;
        that.publicproject()
      },
      // 师傅群组弹框
      workerGroup() {
        let that = this
        that.ownGroup=[]
        getGroupList(objKeySort({
          companyId: that.companyId
        })).then(response => {
          that.workerGroupData = response.data.data;
          that.workerGroupData.forEach(data=>{
            that.inviteGroups.forEach(item=>{
              if(data.id==item.id){
                data.check=true
                that.ownGroup.push(data)
                that.$nextTick(() => {
                  that.$refs.groupCrud.toggleRowSelection(data, true);
                })
              }
            })
          })
        });
        that.workerGroupVisible = true;
      },
      // 师傅群组关闭标签
      workerGroupClose(tag) {
        this.workerGrouptags.splice(this.workerGrouptags.indexOf(tag), 1);
      },

      workerGroupworker(data) {
        this.ownWorker = data;
      },

      getSerialNumber(index) {
        return index + 1;
      },




      // 提交数据
      publicproject() {
        var that = this
        if(that.publishingMode.type==2&&that.ownGroup){
          that.publishingMode.groupIds=that.dataFilter(that.ownGroup);//过滤为id
        }

        if(that.publishingMode.type==3&&that.ownWorker){
          that.publishingMode.worksIds = that.dataFilter(that.ownWorker);//过滤为id
        }

        if (!(that.publishingMode.type>0)) {
          that.$message({
            type:'info',
            message:'至少选择一项发布方式'
          })
          return
        }
        if(that.publishingMode.type==2&&that.publishingMode.groupIds==""){
          that.$message({
            type:'info',
            message:'至少选择一个群组'
          })
          return
        }
        if(that.publishingMode.type==3&&that.publishingMode.worksIds==""){
          that.$message({
            type:'info',
            message:'至少选择一个师傅'
          })
          return
        }

        let submitData = {
          projectId: that.projectId,
          isOen: that.publishingMode.type==1?1:0,
          groupIds: that.publishingMode.groupIds?that.publishingMode.groupIds.join(','):'',
          userIds: that.publishingMode.worksIds?that.publishingMode.worksIds.join(','):''
        }
        updateProjectChannel(objKeySort(submitData)).then(obj=>{
          if(obj.data.code==200){
            that.$message({
              type:'success',
              message:'修改成功'
            })
           that.inviteGroups = that.ownGroup;
           that.inviteWorkers = that.ownWorker;
            that.xqPageVisable.fBDlg=false
          }else{
            that.$message({
              type:'warning',
              message:obj.data.msg
            })
            if(obj.data.msg=='您没有权限修改该工程发布渠道'){
              that.inviteGroups=[]
            }
          }
        })
      },

      //清空
      searchReset() {
        this.page.currentPage = 1;
        this.page.pageSize = 20;
        this.getxmxgr();
      },
      // 过滤出id
      dataFilter(dataItem) {
        var dataArr = [];
        for (var i of dataItem) {
          dataArr.push(i.id);
        }
        return dataArr;
      },
      // 打开项目相关人 弹窗
      stakeholdersDlgShow(){
        let that =this
        if(!that.companyId){
          that.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
          that.companyId = that.userInfo.companyId;
        }
        that.projectManVisible = true;
        that.getxmxgr()
      },
      //搜索数据
      searchChangexgr(params) {
        if (!params.name) {
          params.name = "";
        }
        this.search.conditions = params.name?params.name:this.search.conditions;
        this.getxmxgr();
      },

      //搜索群组信息
      searchChangeqz(params) {
        let searchqz = {
          condition: params.condition ? params.condition : "",
          groupId: params.groupNames,
          isForeman: params.isForeman,
          workTypeId: params.workTypeIds
        };
        getGroupList(objKeySort(dealElement(searchqz))).then(response => {
          this.workerData = response.data.data;
          this.workerData.forEach(data => {
            data.workTypeIds = this.formatterWorkType(data.workTypeIds);
          });
        });

      },

      //搜索师傅信息
      searchChangegr(params) {
        this.searchgr = {
          condition: params.condition ? params.condition : "",
          groupId: params.groupNames,
          isForeman: params.isForeman,
          workTypeId: params.workTypeIds
        };
        getWorkerList(objKeySort(dealElement(this.searchgr))).then(response => {
          this.workerData = response.data.data;
          this.workerData.forEach(data => {
            data.workTypeIds = this.formatterWorkType(data.workTypeIds);
          });
        });
        console.log(this.searchgr);
      },
      //check的项目相关人
      selectionChange(val) {
        let that=this
        if(Object.prototype.toString.call(val)== '[object Array]'){
          that.ownStakeholders = val;
        }else{
          // 有勾选的数据
          if(that.ownStakeholders.length>0){
            // 遍历并判断是否是选择了 已在选择数据中的数据
            that.ownStakeholders.slice().reverse().forEach((citem, index, object)=>{
              if(citem.id==val.id){
                // 取消已经勾选的
                that.ownStakeholders.splice(object.length - 1 - index, 1);
                // citem.check=false
                that.$nextTick(() => {
                    that.$refs.userCrud.toggleRowSelection(val, false);
                });
              }
            })
          }
          if(that.comworkerData.length>0){
            that.comworkerData.forEach(item=>{
              if(item.id==val.id&&item.check==true){
                 item.check=false
                 that.$nextTick(() => {
                   that.$refs.userCrud.toggleRowSelection(item, false);
                 })
              }else if((val.check==undefined||val.check==false)&&item.id==val.id){
                item.check=true
                that.ownStakeholders.push(item)
                that.$nextTick(() => {
                  that.$refs.userCrud.toggleRowSelection(item, true);
                })
              }
            })
          }
        }
        // this.tags = list;
      },


      // 项目相关人确定选择
      chooseTrue() {
        let that = this
        that.projectManVisible = false;
        let _stakeholderIds=''
        if (that.ownStakeholders && that.ownStakeholders.length > 0) {
          that.ownStakeholders.forEach(tag => {
            _stakeholderIds += tag.id + ',';
          });
          _stakeholderIds = _stakeholderIds.substring(0, _stakeholderIds.length - 1);
        }
        updateStakeholders(objKeySort({
          projectId: that.projectId,
          stakeholderIds: _stakeholderIds
        })).then(response => {
          if (response && response.data && response.data.data && response.data.code == 200) {
            let _stakeholders=response.data.data;
            _stakeholders.forEach(item=>{
              if(item.avatar&&item.avatar.indexOf('http')==-1){
                item.avatar=getImgLink(item.avatar)
              }
            })
            that.stakeholders =_stakeholders
          } else {
            that.$message({
              type:'success',
              message:response.data.msg
            });
          }
        })
      },
      // 获取项目相关人信息
      getxmxgr() {
        let that=this
        that.comworkerData = [];
        that.search.companyId = that.companyId;
        that.search.pageNum = 1;
        that.search.pageSize = 999;
        getWorkerInfo(objKeySort(that.search)).then(response => {
          that.page.total = response.data.data.total;
           let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
          response.data.data.rows.forEach(comworker => {
            if (userInfo.id != comworker.id) {
              // comworker.name = comworker.name + "(自己)";
              that.comworkerData.push(comworker);
            }
            if (that.stakeholders.length > 0) {
              that.stakeholders.forEach(tag => {
                if (tag.userId == comworker.id) {
                    comworker.check=true
                    that.ownStakeholders.push(comworker)
                    that.$nextTick(() => {
                      that.$refs.userCrud.toggleRowSelection(comworker, true);
                    })
                }
              });
            }
          });
        });
      },
      // 项目相关人关闭标签
      handleClose(tag) {
        this.ownStakeholders.splice(this.ownStakeholders.indexOf(tag), 1);
        this.$refs.userCrud.toggleRowSelection(tag, false);
      },

      // 新增项目相关负责人
      addProjectPeople() {
        this.projectManVisible = true;
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        this.companyId = this.userInfo.companyId;
        this.getxmxgr();
      },
      //刷新列表操作
      formatterWorkType(workTypeIds) {
        var workTypeNames = "";
        if (workTypeIds && workTypeIds.length > 0) {
          workTypeIds.split(",").forEach(workerTypeId => {
            if (this.dic.workTypes) {
              this.dic.workTypes.forEach(workerType => {
                if (workerType.id == workerTypeId) {
                  workTypeNames = workTypeNames + workerType.name + ",";
                }
              });
            } else {
              return workTypeIds;
            }
          });
        }
        if (workTypeNames.length > 0) {
          workTypeNames = workTypeNames.substring(0, workTypeNames.length - 1);
        }
        return workTypeNames;
      },
      // 初始化师傅列表数据
      initDic() {
        getDictList(objKeySort({
          code: "worktype"
        })).then(response => {
          this.dic.workTypes = response.data.data.worktype;
          this.tableoptionwork.column[3].dicData = response.data.data.worktype;
        });
        getDictList(objKeySort({
          code: "worker_skill"
        })).then(response => {
          this.dic.skillTips = response.data.data.worker_skill;
        });
        fetchList(objKeySort()).then(response => {
          this.dic.groups = response.data.data;
          this.tableoptionwork.column[5].dicData = response.data.data;
        });
      },


      //刷新列表操作
      refresh() {
        this.getCompanyInfo(this.projectId);
      },

      refreshcord() {
        let that =this
        that.activeName = "three";
        that.radiorecord=undefined;
        that.row=undefined;
        that.showDetail=true;
        that.getfeedback();
      },

      //设置展示
      setsataus(data, state, state1) {
        debugger
        this.dialogFormVisible = true;
        this.cancelStateus = state;
        this.projectId = data;
        this.statecancel = state1 ? state1 : "";
        this.getReports = [];
        this.getCompanyInfo(data);
      },

      //详情展示
      handleClick(tab) {
        let that =this
        that.activeName = tab.name;
        that.showExtraCosts=false;
        if (tab.name == "second") {
          that.getProgInfo();
        } else if (tab.name == "three") {
          that.showDetail=true;
          that.radiorecord=undefined
          that.getfeedback();
        }else if (tab.name == "four") {
          that.showExtraCosts=true;
          that.extracostsObj=undefined;
          that.picPaths=[];
          that.extracostsPriceSum='';
          that.getProjectExtraCosts();
        }
        // this.activeName = 'second';
      },

      //查询 额外费用
      getProjectExtraCosts(){
        let that = this
        getProjectExtraCosts(objKeySort({
          projectId: that.projectId
        })).then(response=>{
          if(response.status==200&&response.data.data){
            let _priceSum=0
            if(response.data.data.length){
              response.data.data.forEach(data=>{
              let _picPaths=data.picPaths?data.picPaths.split(','):[];
              let newPicPathArray = [];
              _picPaths.forEach(citem=>{
               newPicPathArray.push(getImgLink(citem)+'')
              })
              data.picPaths=newPicPathArray;
              data.createTime = dateY(data.createTime);
              })
            }
            that.extracostsPriceSum=_priceSum;
            that.extracostsObj=response.data.data;
          }
        })
      },

      //查看工作内容详情
      openContentInfo(content) {
        this.$refs.contentInfo.setData(content);
      },

      //项目详情数据请求
      getCompanyInfo(data) {
        let that = this
        that.activeName = "first";
        getProjectInfo(objKeySort({
          projectId: data
        })).then(response => {
          that.initDic();
          that.projectName = response.data.data.projectName;
          that.state = response.data.data.state;
          that.address = response.data.data.projectAddresses;
          that.startTime = that.settime(response.data.data.startTime);
          that.startTimeTemp = that.settime(response.data.data.startTime);
          that.duration = response.data.data.duration;

          that.planDateForm.duration=that.duration;
          that.planDateForm.startTime=that.startTime;


          that.durationTemp = response.data.data.duration;
          that.workTypeTableTemp=JSON.parse(response.data.data.workTypeTable);
          that.isOvertime = response.data.data.isOvertime;
          that.workTypes = JSON.parse(response.data.data.workTypes);
          that.domains = that.getContents(response.data.data.workProjectContents); //工作内容
          that.describe = response.data.data.describe;
          that.workTypeTable = JSON.parse(response.data.data.workTypeTable);
          that.relevantContacts = JSON.parse(response.data.data.relevantContacts); //协作人
          that.companyId=response.data.data.companyId;//公司id
          // 初始化表格
          that.initTableData(JSON.parse(response.data.data.workTypeTable))

          let _stakeholders=response.data.otherData.stakeholders?response.data.otherData.stakeholders : [];
          _stakeholders.forEach(item=>{
            if(item.avatar){
              item.avatar=getImgLink(item.avatar)
            }
          })
          that.stakeholders =_stakeholders

          //置空filePathsEl
          that.filePathsEl=[]
          that.filePaths = JSON.parse(response.data.data.filePaths);
          //转换filePaths 用于el结构
          if (JSON.parse(response.data.data.filePaths) && JSON.parse(response.data.data.filePaths).length > 0) {
            that.filePathsEl = that.changeToel(that.filePaths)
          }
          //对比用户信息 看是否有修改权限
          let userInfo=JSON.parse(sessionStorage.getItem("userInfo"))
          if(userInfo.id==response.data.data.userId||userInfo.roleid==3){
            that.isEditAuth=true
          }

          that.refuse =
            response.data.otherData.cancelInfos != undefined ?
            response.data.otherData.cancelInfos : [];
          that.companyName = response.data.data.companyName;
          that.userName = response.data.data.userName;
          that.createTime = that.settime(response.data.data.createTime);
          that.isOpen = response.data.data.isOpen;
          if (response.data.otherData.inviteWorkers) {
            that.inviteWorkers = response.data.otherData.inviteWorkers;
            that.publishingMode.type = '3'
          }
          if (response.data.otherData.inviteGroups) {
            that.inviteGroups = response.data.otherData.inviteGroups;
            that.publishingMode.type = '2'
          }

          //处理展示验收报告
          if (
            Number(response.data.data.state) == 5 ||
            Number(response.data.data.state) == 6 ||
            Number(response.data.data.state) == 7
          ) {
            that.getReport(response.data.data.projectId);
          }
          //应招师傅
          if (response.data.otherData && response.data.otherData.foremanInfo.length > 0) {
            response.data.otherData.foremanInfo.forEach(foremanInfo => {
              foremanInfo.createTime = dateY(foremanInfo.createTime);
            })
            that.foremanInfo = response.data.otherData.foremanInfo
          }
          //拒绝结项数据
          let _refuseLog=response.data.otherData.refuseProjectFinishLogs
          if(_refuseLog&&_refuseLog.length>0){
            _refuseLog.forEach(item=>{
              item.createTime= that.settime(item.createTime);
            })
            that.refuseLog=_refuseLog
          }
          that.projectInfo.priceSum=response.data.data.priceSum?response.data.data.priceSum:'-';
          that.projectInfo.price=response.data.data.price?response.data.data.price:'-';
          that.projectInfo.projectType=response.data.data.projectType;
          that.projectInfo.workTypes=JSON.parse(response.data.data.workTypes);
          that.projectInfo.state=response.data.data.state

          that.prospecting=response.data.data.projectPlanProspectings;

          let daohuoPlanList = response.data.data.projectPlanDaohuos;
          daohuoPlanList.forEach(item=>{
            item.carIformationList = JSON.parse(item.carIformationList);
            item.arrivalDataInfo = JSON.parse(item.arrivalDataInfo);
          })


          that.daohuoPlanList=daohuoPlanList;
          that.installationPlanList=response.data.data.projectPlanInstallations;
          that.arrivalPlanList=response.data.data.projectPlanArrivals;
          that.returnVisitPlanList=response.data.data.projectPlanReturnvisits;



          that.initTypeTable(1);

          //设置 发布人头像
          let _avatar=response.data.data.createUserInfo.avatar
          if(_avatar&&(_avatar.indexOf('http')==-1)){
            that.creatUserInfo.avatar=getImgLink(_avatar);
          }
          that.creatUserInfo.headimgurl=response.data.data.createUserInfo.headimgurl
        });
      },
      //重新整理工作内容数据
      getContents: function(data) {
        var contents = [];
        data.forEach(content => {
          var firstImg = '';
          var imgNum = 0;
          var vidNum = 0;
          let imgPaths = content.imgPaths ? content.imgPaths.split(',') : [];
          let videoPaths = content.videoPaths ? content.videoPaths.split(',') : [];
          if (imgPaths && imgPaths.length > 0) {
            imgNum = imgPaths.length;
            firstImg = imgPaths[0];
          }
          if (videoPaths && videoPaths.length > 0) {
            vidNum = videoPaths.length
          }
          contents.push({
            tips: content.tips,
            firstImg: firstImg ? firstImg : '',
            imgPaths: content.imgPaths,
            videoPaths: content.videoPaths,
            imgNum: imgNum,
            videoNum: vidNum,
            contentId: content.contentId
          })
        })
        return contents;
      },

      //更改变量名
      changeToel(arr) {
        console.log(typeof arr)
        let data = []
        if (toString.call(arr) == '[object Array]') {
          arr.forEach(item => {
            let fItem = {}
              fItem.name = item.name,
              fItem.companyId = item.companyId,
              fItem.createTime = item.createTime,
              fItem.url = item.url,
              fItem.fileTips = item.fileTips,
              fItem.id = item.id,
              fItem.userId = item.userId
              fItem.type = matchType(item.name)
            data.push(fItem)
          })
          return data
        } else if (toString.call(arr) == '[object Object]') {
          let fItem = {}
          fItem.name = arr.name?arr.name:arr.fileName,
            fItem.companyId = arr.companyId,
            fItem.createTime = arr.createTime,
            fItem.url = arr.url?arr.url:arr.filePath,
            fItem.fileTips = arr.fileTips,
            fItem.id = arr.id,
            fItem.userId = arr.userId
          fItem.type = matchType(fItem.name)
          data.push(fItem)
          return data
        }
      },

      //默认时间
      settime(data) {
        return dateOnce(data);
      },

      //产看结项图片
      showysbg(data) {
        this.$refs.imgchild.imgstate(data);
      },

      //查看已招师傅信息
      recruitment() {
        this.$refs.workerchild.workerstate(this.works);
      },

      //查看日志
      journal() {
        this.$refs.recordchild.recordstate(this.projectId, this.state);
      },

      // 关闭项目
      handleStop() {
        this.dialogStop = true;
      },

      //拒绝时间
      refusetime(data) {
        return dateOnce(data);
      },
      //查看进度
      showprogress() {
        this.$refs.child2.setsataus(this.projectId);
      },
      //取消项目
      cancelProject() {
        this.$refs.child3.setsataus(this.projectId, "取消原因");
      },
      //重新发布项目
      againproject() {
        this.$router.push("/project/add");
        sessionStorage.setItem("editProject",
        JSON.stringify({
          type:'release',
          projectId:this.projectId
        }))
      },
      update(){
        this.$router.push("/project/add");
        sessionStorage.setItem("editProject",
        JSON.stringify({
          type:'update',
          projectId:this.projectId
        }))
      },
      //拒绝结项
      refusebtn() {
        this.$refs.child3.setsataus(this.projectId, "拒绝原因");
      },
      //同意结项
      agreebtn() {
       var that = this;
       var count = 0;
       getFeedbacks(objKeySort({
         projectId: that.projectId
       })).then(response => {
         if(response.data.code==200&&response.data.data&&response.data.data.length>0){
           response.data.data.forEach(function (feedback) {
             if (feedback.flag == 0) {
               count++;
             }
           });
           that.$confirm(count > 0 ? '您的项目还有' + count + '个反馈没有解决，您确定要结项吗？' : '您确认要结项吗？', '温馨提示', {
             distinguishCancelAndClose: true,
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning',
           }).then(() => {
             agree(objKeySort({
               projectId: that.projectId
             })).then(response => {
               if(response.data.code==200){
                 that.$message({
                   type: 'success',
                   message: '结项成功'
                 });
                 that.getCompanyInfo(that.projectId);
               }else {
                 that.$message({
                   type: 'warning',
                   message: response.data.msg
                 });
               }
             });
           }).catch(()=> {
             console.log('用户点击取消');
           });
         }else{
           that.$confirm('您确定要结项吗？', '温馨提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
           }).then(() => {
             agree(objKeySort({
               projectId: that.projectId
             })).then(response => {
               if (response.data.code == 200) {
                 that.$message({
                   type: 'success',
                   message: '结项成功'
                 });
                 that.getCompanyInfo(that.projectId);
               } else {
                 that.$message({
                   type: 'warning',
                   message: response.data.msg
                 });
               }
             })
           }).catch(() => {
           });
         }
       });

      },
      //获取结项图片
      getReport(data) {
        getReport(objKeySort({
          projectId: data
        })).then(response => {
          let that = this
          let imgArr = response.data.data.imgPaths ? response.data.data.imgPaths.split(",") : []
          imgArr.forEach((item, index) => {
            imgArr[index] = that.getimgpath(item)
          })
          that.getReports = imgArr
        });
      },
      //删除项目
      deleteProject() {
        deletOrder(objKeySort({
          projectId: this.projectId
        })).then(response => {
          console.log(response)
          this.$emit("refresh");
          this.dialogFormVisible = false;
        });
      },
      //图片路径处理
      getimgpath(data) {
        return getImgLink(data);
      },
      //添加日志反馈
      addcomment(type) {
        this.$refs.childinsert.setProjectId(this.projectId,type);
      },
      //查看进度详情
      getProgInfo() {
        getProgInfo(objKeySort({
          projectId: this.projectId
        })).then(response => {
          let that = this
          let _logs = []
          if (response.data.data) {
            _logs = response.data.data
            _logs.forEach(item => {
              item.projectLogs.forEach(log => {
                log.createTime = dateSplit(log.createTime, 1)
                log.isShow = false
                if(log.content=='修改附件'){
                  let obj=JSON.parse(log.contentData);
                  if(obj.logType){
                    log.contentData=obj.logType +'附件' + obj.name
                  }else{
                    log.contentData=''
                  }
                }else if(log && log.type != 1 && log.contentData && log.contentData != null){
                  log.contentData = JSON.parse(log.contentData)
                }

                if(log.content=='修改项目相关人'){
                  try {
                    let obj=JSON.parse(log.contentData);
                    if(obj.projectId){
                      log.contentData='';
                    }else{
                      log.contentData=obj;
                    }
                  } catch (e) {
                    log.contentData=log.contentData;
                    return false;
                  }
                 }

                 if(log.content=='修改协作联系人'){
                   try {
                     let obj=JSON.parse(log.contentData);
                     log.contentData='';
                   } catch (e) {
                     log.contentData=log.contentData;
                   }
                 }

                 if(log.content=='修改地址联系人'){
                   try {
                     let obj=JSON.parse(log.contentData);
                     log.contentData='';
                   } catch (e) {
                     log.contentData=log.contentData;
                   }
                 }
                if(log.avatar&&log.avatar.indexOf('http')==-1){
                  log.avatar=getImgLink(log.avatar)
                }
              })
            })
          }
          that.logs = _logs
        });
      },
      // 是否显示更多信息
      showBtn(e) {
        let that = this
        that.logs[e.currentTarget.dataset.index1].projectLogs[e.currentTarget.dataset.index2].isShow = !that.logs[e.currentTarget
          .dataset.index1].projectLogs[e.currentTarget.dataset.index2].isShow;
      },
      getfeedback() {
        getFeedbacks(objKeySort({
          projectId: this.projectId
        })).then(response => {
          this.radiorecord = undefined;
          this.record.data = response.data.data;
          this.page.total = response.data.data.length;
          this.getFeedBackFlag=true
        });
      },
      //查看视频详情
      showVideo(data, type) {
        this.$refs.childvideo.viderstate(data, type);
      },
      //查看反馈详情信息
      showcomment() {
        let that = this
        this.showDetail=true
        that.$refs.childcomment.commentstate(
          that.radiorecord,
          that.serviceType,
          that.state,
          that.projectId
        );
      },
      //查看反馈详情 进度入口
      showcomment2(obj) {
        let that = this
        that.$refs.childcomment.commentstate(
          obj.contentData.id,
          obj.contentData.type,
          obj.contentData.projectState,
          that.projectId
        );
      },
      showRow(row) {
        this.radiorecord = row.id;
        this.serviceType = row.type;
        this.recordStatus = false;
        this.handleRowClick(row);
      },
      handleRowClick(row){
        if(row){
          this.showDetail=false
        }else{
          this.radiorecord=undefined
          this.showDetail=true
        }
      },
      //弹窗
      isShowFjDlg() {
        this.xqPageVisable.fJDlg = true
        this.fjData.isShowDel = true
      },
      fjClose() {
        this.fjData.isShowDel = false
      },

      isShowBzDlg() {
        let that = this
        that.bzInput = that.describe
        that.xqPageVisable.bZDlg = true
      },
      isShowPbDlg() {
        this.xqPageVisable.pBDlg = true
        this.startTimeTemp=this.startTime
        this.initTypeTable(5)//初始化表格数据
      },
      //发布方式选择弹窗
      isShowFbDlg() {
        this.xqPageVisable.fBDlg = true
      },


      isShowPlanDateDlg() {
        let that = this
        that.xqPageVisable.planDateDlg = true
      },
      isShowBasePlanDlg() {
        let that = this
        that.bzInput = that.describe
        that.xqPageVisable.basePlanDlg = true
      },
      isShowDaohuoPlanDlg() {
        let that = this
        that.bzInput = that.describe
        that.xqPageVisable.daohuoPlanDlg = true
      },
      isShowInstallPlanDlg() {
        let that = this
        that.bzInput = that.describe
        that.xqPageVisable.installPlanDlg = true
      },



      //反馈分页
      currentChange(val) {
        this.page.currentPage = val;
        this.getfeedback()
      },
      //刷新 父级页面
      refreshUp(){
        this.showExtraCosts=false;
        this.$emit('refresh','');
        this.dialogFormVisible=false
      },
      refreshFeedBackList(){
        this.radiorecord=undefined
        this.getfeedback()
        this.row=undefined
      },
      //项目修改金额 弹窗
      showpriceDlg(){
        let that=this
        that.changeForm.allPrice=that.projectInfo.price;
        that.xqPageVisable.jeDlg = true;
      },
      // 格式金额
      _formatAmount(e) {
        const val = e.target.value;
        const cVal = val * 1;

        if (cVal) {
          e.target.value = toFixed2(cVal);
          this.changeForm.allPrice = toFixed2(cVal);
        }
      },
      //提交 金额修改
      updatePrice(){
        let that=this
        let mdata = {
          'projectId':that.projectId,
          'price': that.changeForm.allPrice
        }
        updateProjectPrice(objKeySort(mdata)).then(response=>{
          if(response.data.code==200){
            that.$message({
              type: 'success',
              message: '修改成功'
            })
            debugger
            if(that.projectInfo.state==0){
              that.projectInfo.priceSum=that.changeForm.allPrice;
              that.projectInfo.price=that.changeForm.allPrice;
            }else{
              that.projectInfo.price=that.changeForm.allPrice;
            }
            that.xqPageVisable.jeDlg = false;
          }else{
            that.$message({
              type: 'error',
               message: '操作失败，请联系管理员'
            })
            that.xqPageVisable.jeDlg = false;
          }
        })
      },



      planDataInfo(type,content) {
        let that = this;
        switch (type) {
          case 1 : that.planTypeName="勘查",that.$refs.basePlanInfo.setData(1,content); break;
          case 2 : that.$refs.daohuoPlanInfo.setData(content); break;
          case 3 : that.$refs.installPlanInfo.setData(content); break;
          case 4 : that.planTypeName="验收",that.$refs.basePlanInfo.setData(4,content); break;
          case 5 : that.planTypeName="回访",that.$refs.basePlanInfo.setData(5,content); break;
          default:
            that.$message({
              type: 'error',
              message: '计划类型参数错误'
            });
            return;
        }
      },

      editPlanData(type,content) {
        let that = this;
        switch (type) {
          case 1 : that.planTypeName="勘查",that.$refs.editBasePlan.setData(1,content,2); break;
          case 2 : that.$refs.editDaohuoPlan.setData(content,2); break;
          case 3 : that.$refs.editInstallPlan.setData(3,content,2); break;
          case 4 : that.planTypeName="验收",that.$refs.editBasePlan.setData(4,content,2); break;
          case 5 : that.planTypeName="回访",that.$refs.editBasePlan.setData(5,content,2); break;
          default:
            that.$message({
              type: 'error',
              message: '计划类型参数错误'
            });
            return;
        }
      },

      //修改项目计划回调
      updatePlanData(type,data){
        console.log("修改计划：",type,data);
        let that = this;
        switch (type) {
          case 1 : that.insertOrUpdateProjectPlanProspecting(data); break;
          case 2 : that.insertOrUpdateProjectPlanDaohuo(data); break;
          case 3 : that.insertOrUpdateProjectPlanInstallation(data); break;
          case 4 : that.insertOrUpdateProjectPlanArrival(data); break;
          case 5 : that.insertOrUpdateProjectPlanReturnvisit(data); break;
          default:
            that.$message({
              type: 'error',
              message: '计划类型参数错误'
            });
            return;
        }
      },

      //修改勘察计划
      insertOrUpdateProjectPlanProspecting(data){
        let that=this
        let mdata = {
          planDate:data.planDate,
          content:data.content,
          projectId:data.projectId
        }
        if(data.id){
          mdata.id = data.id
        }
        insertOrUpdateProjectPlanProspecting(objKeySort(mdata)).then(response=>{
          if(response.data.code==200){
            that.$message({
              type: 'success',
              message: '修改成功'
            })
            that.refresh();
          }else{
            that.$message({
              type: 'error',
              message: '操作失败，请联系管理员'
            })
          }
        })
      },

      //修改到货计划
      insertOrUpdateProjectPlanDaohuo(data){
        console.log("修改到货计划：",data);
        let that=this

        let mdata = {
          planDate:data.planDate,
          logisticsNo:data.logisticsNo,
          logisticsCompany:data.logisticsCompany,
          logisticsUser:data.logisticsUser,
          phone:data.phone,

          isTransport:data.isTransport,
          arrivalMode:data.arrivalMode,
          arrivalDataInfo:JSON.stringify(data.arrivalDataInfo),
          carIformationList:JSON.stringify(data.carIformationList),
          fangshuSum:data.fangshuSum,
          index:data.index?data.index:0,
          dateTimeIndex:0,
          projectId:data.projectId
        }
        if(data.id){
          mdata.id = data.id
        }
        insertOrUpdateProjectPlanDaohuo(objKeySort(mdata)).then(response=>{
          if(response.data.code==200){
            that.$message({
              type: 'success',
              message: '修改成功'
            })
            that.refresh();
          }else{
            that.$message({
              type: 'error',
              message: '操作失败，请联系管理员'
            })
          }
        })
      },

      //修改安装计划
      insertOrUpdateProjectPlanInstallation(data){
        let that=this
        let mdata = {
          planDate:data.planDate,
          content:data.content,
          anzhuangNum:data.anzhuangNum,
          banyunNum:data.banyunNum,
          workOvertime:data.workOvertime,
          projectId:data.projectId
        }
        if(data.id){
          mdata.id = data.id
        }
        insertOrUpdateProjectPlanInstallation(objKeySort(mdata)).then(response=>{
          if(response.data.code==200){
            that.$message({
              type: 'success',
              message: '修改成功'
            })
            that.refresh();
          }else{
            that.$message({
              type: 'error',
              message: '操作失败，请联系管理员'
            })
          }
        })
      },

      //修改验收计划
      insertOrUpdateProjectPlanArrival(data){
        let that=this
        let mdata = {
          planDate:data.planDate,
          content:data.content,
          projectId:data.projectId
        }
        if(data.id){
          mdata.id = data.id
        }
        insertOrUpdateProjectPlanArrival(objKeySort(mdata)).then(response=>{
          if(response.data.code==200){
            that.$message({
              type: 'success',
              message: '修改成功'
            })
            that.refresh();
          }else{
            that.$message({
              type: 'error',
              message: '操作失败，请联系管理员'
            })
          }
        })
      },
      //修改回访计划
      insertOrUpdateProjectPlanReturnvisit(data){
        let that=this
        let mdata = {
          planDate:data.planDate,
          content:data.content,
          projectId:data.projectId
        }
        if(data.id){
          mdata.id = data.id
        }
        insertOrUpdateProjectPlanReturnvisit(objKeySort(mdata)).then(response=>{
          if(response.data.code==200){
            that.$message({
              type: 'success',
              message: '修改成功'
            })
            that.refresh();
          }else{
            that.$message({
              type: 'error',
              message: '操作失败，请联系管理员'
            })
          }
        })
      },


      //提交 计划工期修改
      updatePlanDate(){
        let that=this
        console.log("提交 计划工期修改","updatePlanDate")
        let mdata = {
          'projectId':that.projectId,
          'duration': that.planDateForm.duration,
          'startTime': that.planDateForm.startTime
        }
        updateProjectPlanDate(objKeySort(mdata)).then(response=>{
          if(response.data.code==200){
            that.$message({
              type: 'success',
              message: '修改成功'
            })
            that.refresh();
            that.xqPageVisable.planDateDlg = false;
          }else{
            that.$message({
              type: 'error',
               message: '操作失败，请联系管理员'
            })
          }
        })
      },
      //显示 补充说明弹窗
      showAddInfo(i){
        let that=this;
        that.extracostsObj.forEach((item,index)=>{
          if(index==i){
            that.extracostsObjSelect=item;
            that.companyInfo=item.companyTips;
            that.xqPageVisable.smDlg=true;
            return
          }
        })
      },
      //提交 补充说明
      updateAddInfo(){
        let that=this;
        if(!that.companyInfo){
          that.$message({
            type: 'warning',
            message: '请输入补充费用说明'
          });
          return
        }
        let mdata={
          id: that.extracostsObjSelect.id,
          companyTips:that.companyInfo
        }
        updateProjectExtraCostsCompanyTips(objKeySort(mdata)).then(response=>{
          if(response.data.code==200){
            that.$message({
              type: 'success',
              message: '提交成功'
            });
            that.xqPageVisable.smDlg=false;
            that.showExtraCosts=true;
            that.extracostsObj=undefined;
            that.picPaths=[];
            that.extracostsPriceSum='';
            that.getProjectExtraCosts();
          }
        })
      }
    },
    components: {
      record,
      refuse,
      showReport,
      videolist,
      comment,
      insertrecord,
      contentInfo,
      myAvatar, //头像组件
      myWorkContentList, //工作内容list 组件
      myWorkFj, //工作附件list 组件
      myPicList, //图片list 组件
      easyTable, //可编辑表格
      myTable, //表格组件
      sendWays, //发布方式组件
      comment2, //新的项目反馈组件
      editBasePlan,
      editDaohuoPlan,
      editInstallPlan,
      basePlanInfo,
      daohuoPlanInfo,
      installPlanInfo,
    },
  };
</script>

<style lang="scss" scoped>
  .form_layout_items {
    display: flex;
  }

  .select_option {
    position: absolute;
    z-index: 22;
    width: 150px !important;
    right: 0;
    top: 0;
  }

  .el-table ::v-deep .el-table__row:nth-child(even) {
    background-color: #f6f9ff !important;
  }

  .form_layout_item {
    width: 50%;
    border: 1px solid #fff;
    height: 80px;
  }

  .projectimg {
    width: 130px;
    float: right;
    display: block;
    margin-top: -75px;
    margin-bottom: 10px;
  }

  .tag {
    margin-right: 10px;
  }

  .pro_address .pro_main div a {
    height: auto;
  }

  .info_text {
    font-size: 12px;
    color: rgba(25, 31, 37, 0.8);
    background: rgba(245, 247, 250, 1);
    border-radius: 2px;
    margin-bottom: 12px;
    min-height: 40px;
    padding-left: 15px;
    position: relative;
    cursor: pointer;
    display: flex;

    & div {
      line-height: 40px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 70%;

    }

    a {
      line-height: 40px;
      margin-left: 32px;

      img {
        vertical-align: middle;
        margin-top: -1px;
        margin-right: 5px;
      }
    }

    .del {
      position: absolute;
      top: 14px;
      right: 16px;
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }

  .info_text:hover {
    background: rgba(255, 192, 0, 0.1);
  }
  .man_list {
    flex-wrap: wrap;
    display: flex;
    .ava_img {
      min-width: 50px;
      text-align: center;

      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }

      view:nth-of-type(1) {
        width: 32px;
        height: 32px;
        text-align: center;
        margin: auto;
      }
    }
    .ava_name {
      font-size: 12px;
      color: rgba(25, 31, 37, 0.8);
      min-width: 50px;
    }
  }
  .refuseRes+,.refuseRes{
    margin-top: 20px;
  }
  .for-long-btn{
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .for-long-btn:hover{
    background: rgba(255, 192, 0, 0.1);
  }

  .keysearch ::v-deep  .el-button--primary:hover{
    background:rgba(61,126,255,1);
  }
  .height-36{
    margin-top: 20px;
  }

  .height-36 ::v-deep .el-form-item__content{
    width: auto !important;
  }
  ::v-deep .el-dialog__body{
    min-height: 100px;
  }
</style>
